import GeneralMedicine from './assets/Images/General Medicine.jpg';
import pulmonology from './assets/Images/pulmonology.jpg';
import treatmentFollowed from './assets/Images/TreatmentFollowed.jpg';
import GeneralMedicine1 from './assets/Images/servicesImgs/general_med_1.jpg';
import GeneralMedicine2 from './assets/Images/servicesImgs/general_med_2.jpg';
import GeneralMedicine3 from './assets/Images/servicesImgs/general_med_3.jpg';
import drsvg from './assets/DocImages/svgDr.svg'
import DermotologyIcon from './assets/Images/serviceIcon/website icon-24.png';
import OrthopedicIcon from './assets/Images/serviceIcon/website icon-23.png';
import amrish from "./assets/DocImages/amrishsir.jpg"
import mahendra from "./assets/DocImages/mahendra.jpeg"
import swethaD from "./assets/DocImages/shwetamaam.jpeg"
import sindhu from "./assets/DocImages/Dr Swetha Kodali.jpg"
import vamsi from "./assets/DocImages/vamsikrishnasir.jpeg"
import gen_med_1 from "./assets/Images/servicesImgs/general_med_1.jpg"
import gen_med_2 from "./assets/Images/servicesImgs/general_med_2.jpg"
import gen_med_3 from "./assets/Images/servicesImgs/general_med_3.jpg"



// Icons for Services
import GeneralMediIcon from "./assets/Images/serviceIcon/website icon-27.png"
import pulmoIcon from "./assets/Images/serviceIcon/website icon-25.png"
import crticalIcon from "./assets/Images/serviceIcon/website icon-01.png"
import anesthetia from "./assets/Images/serviceIcon/website icon-02.png"
import Psychiatry from "./assets/Images/serviceIcon/website icon-03.png"
import cardioIcon from "./assets/Images/serviceIcon/website icon-20.png"
import medicalOncology from "./assets/Images/serviceIcon/website icon-06.png"
import gastroenterology from "./assets/Images/serviceIcon/website icon-07.png"
import nephrology from "./assets/Images/serviceIcon/website icon-08.png" 
import generalSurgery from "./assets/Images/serviceIcon/website icon-09.png"
import gynecology from "./assets/Images/serviceIcon/website icon-10.png"
import urology from "./assets/Images/serviceIcon/website icon-11.png"
import ent from "./assets/Images/serviceIcon/website icon-12.png"
import spineSurgery from "./assets/Images/serviceIcon/website icon-13.png"
import neurology from "./assets/Images/serviceIcon/website icon-04.png"
import radiology from "./assets/Images/serviceIcon/website icon-05.png"
import omfs from "./assets/Images/serviceIcon/website icon-29.png"
import vascular from "./assets/Images/serviceIcon/website icon-28.png"
import pedeiatrics from "./assets/Images/serviceIcon/website icon-21.png"













import pulmo_img_1 from "./assets/Images/servicesImgs/pulmonology_1.jpg"
import pulmo_img_2 from "./assets/Images/servicesImgs/pulmonology_2.jpg"
import pulmo_img_3 from "./assets/Images/servicesImgs/pulmonology_3.jpg"


import pedia_img_1 from "./assets/Images/servicesImgs/pediatrics_1.jpg"
import pedia_img_2 from "./assets/Images/servicesImgs/pediatrics_2.jpg"
import pedia_img_3 from "./assets/Images/servicesImgs/pediatrics_3.jpg"


import critical_img_1 from "./assets/Images/servicesImgs/critical_1.jpg"
import critical_img_2 from "./assets/Images/servicesImgs/critical_2.jpg"
import critical_img_3 from "./assets/Images/servicesImgs/critical_3.jpg"
import critical_img_4 from "./assets/Images/servicesImgs/critical_4.jpg"


import anesthe_img_1 from "./assets/Images/servicesImgs/anesthesia_1.jpg"
import anesthe_img_2 from "./assets/Images/servicesImgs/anesthesia_2.jpg"
import anesthe_img_3 from "./assets/Images/servicesImgs/anesthesia_3.jpg"
import anesthe_img_4 from "./assets/Images/servicesImgs/anesthesia_4.jpg"


import cardio_img_1 from "./assets/Images/servicesImgs/cardiology_1.jpg"
import cardio_img_2 from "./assets/Images/servicesImgs/cardiology_2.jpg"
import cardio_img_3 from "./assets/Images/servicesImgs/cardiology_3.jpg"
import cardio_img_4 from "./assets/Images/servicesImgs/cardiology_4.jpg"


import dermi_img_1 from "./assets/Images/servicesImgs/dermatology_1.jpg"
import dermi_img_2 from "./assets/Images/servicesImgs/dermatology_2.jpg"
import dermi_img_3 from "./assets/Images/servicesImgs/dermatology_3.jpg"
import dermi_img_4 from "./assets/Images/servicesImgs/dermatology_4.jpg"

import psyc_img_1 from "./assets/Images/servicesImgs/psychiatry_1.jpg"
import psyc_img_2 from "./assets/Images/servicesImgs/psychiatry_2.jpg"
import psyc_img_3 from "./assets/Images/servicesImgs/psychiatry_3.jpg"
import psyc_img_4 from "./assets/Images/servicesImgs/psychiatry_4.jpg"

import neuro_img_1 from "./assets/Images/servicesImgs/neurology_1.jpg"
import neuro_img_2 from "./assets/Images/servicesImgs/neurology_2.jpg"
import neuro_img_3 from "./assets/Images/servicesImgs/neurology_3.jpg"
import neuro_img_4 from "./assets/Images/servicesImgs/neurology_4.jpg"

import radio_img_1 from "./assets/Images/servicesImgs/radiology_1.jpg"
import radio_img_2 from "./assets/Images/servicesImgs/radiology_2.jpg"
import radio_img_3 from "./assets/Images/servicesImgs/radiology_3.jpg"
import radio_img_4 from "./assets/Images/servicesImgs/radiology_4.jpg"


import ocno_img_1 from "./assets/Images/servicesImgs/oncology_1.jpg"
import ocno_img_2 from "./assets/Images/servicesImgs/oncology_2.jpg"
import ocno_img_3 from "./assets/Images/servicesImgs/oncology_3.jpg"
import ocno_img_4 from "./assets/Images/servicesImgs/oncology_4.jpg"

import gastro_img_1 from "./assets/Images/servicesImgs/gastroenterology_2.jpg"
import gastro_img_2 from "./assets/Images/servicesImgs/gastroenterology_3.jpg"
import gastro_img_3 from "./assets/Images/servicesImgs/gastroenterology_4.jpg"

import nephro_img_1 from "./assets/Images/servicesImgs/nephrology_1.jpg"
import nephro_img_2 from "./assets/Images/servicesImgs/nephrology_2.jpg"
import nephro_img_3 from "./assets/Images/servicesImgs/nephrology_4.jpg"
import nephro_img_4 from "./assets/Images/servicesImgs/nephrology_5.jpg"


import gyno_img_1 from "./assets/Images/servicesImgs/gynecology_1.jpg"
import gyno_img_2 from "./assets/Images/servicesImgs/gynecology_2.jpg"
import gyno_img_3 from "./assets/Images/servicesImgs/gynecology_3.jpg"
import gyno_img_4 from "./assets/Images/servicesImgs/gynecology_4.jpg"

import ortho_img_1 from "./assets/Images/servicesImgs/orthopedics_3.jpg"
import ortho_img_2 from "./assets/Images/servicesImgs/orthopedics_4.jpg"
import ortho_img_3 from "./assets/Images/servicesImgs/orthopedics_5.jpg"

import urology_img_1 from "./assets/Images/servicesImgs/urology_1 (2).jpg"
import urology_img_2 from "./assets/Images/servicesImgs/urology_4.jpg"
import urology_img_3 from "./assets/Images/servicesImgs/urology_5 (2).jpg"
import urology_img_4 from "./assets/Images/servicesImgs/urology_5.jpg"


import ent_img_1 from "./assets/Images/servicesImgs/ent_1.jpg"
import ent_img_2 from "./assets/Images/servicesImgs/ent_2.jpg"
import ent_img_3 from "./assets/Images/servicesImgs/ent_3.jpg"
import ent_img_5 from "./assets/Images/servicesImgs/ent_5.jpg"

import spine_img_1 from "./assets/Images/servicesImgs/spine_surgery_1.jpg"
import spine_img_2 from "./assets/Images/servicesImgs/spine_surgery_2.jpg"
import spine_img_3 from "./assets/Images/servicesImgs/spine_surgery_3.jpg"
import spine_img_4 from "./assets/Images/servicesImgs/spine_surgery_4.jpg"

import plastic_img_1 from "./assets/Images/servicesImgs/plastic_img_1.jpg"
import plastic_img_2 from "./assets/Images/servicesImgs/plastic_img_2.jpg"

import vascular_img_1 from "./assets/Images/servicesImgs/vascular_img_1.jpg"
import vascular_img_2 from "./assets/Images/servicesImgs/vascular_img_2.jpg"
import vascular_img_3 from "./assets/Images/servicesImgs/vascular_img_3.jpg"
import vascular_img_4 from "./assets/Images/servicesImgs/vascular_img_4.jpg"

import omfs_img_1 from "./assets/Images/servicesImgs/omfs_img_1.jpg"
import omfs_img_2 from "./assets/Images/servicesImgs/omfs_img_2.jpg"
import omfs_img_3 from "./assets/Images/servicesImgs/omfs_img_3.jpg"
import omfs_img_4 from "./assets/Images/servicesImgs/omfs_img_4.jpg"
const Departments = {
  medical: [
    {
      title: 'General Medicine',
      Icon: GeneralMediIcon,
      description: 'Comprehensive healthcare for adults with a focus on prevention and treatment.',
      cardDes: 'For your overall well-being and wellness we have a team of experts that care and treat common illnesses with comprehensive care.',
      aboutTitle: "What is General Medicine?",
      metaTitle: "Best General Medicine Hospital in Hyderabad | Magnaid Hospials",
      metaDescription: "MagnAid Hospitals is the best general medicine hospital in Yousufguda, Hyderabad, offering top general and internal medicine treatments. Book your consult now!.",
      metaUrl: "general-medicine",
      about: [
        'General Medicine, also known as Internal Medicine, is a key department at MagnAid Hospital that focuses on the diagnosis, treatment, and prevention of a wide range of diseases and medical conditions.',
        'At MagnAid Hospital, our highly skilled and experienced physicians specialize in diagnosing and treating a wide range of adult conditions, including those related to the heart, lungs, kidneys, digestive system, and more.',
        'If in case, the condition worsens our physicians will refer to our in-house specialists like pulmonologists, cardiologists, gastroenterologists and other specialists.'
      ],

      image: GeneralMedicine,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Our physicians at MagnAid Hospital are highly experienced in managing a wide range of adult health conditions through advanced, non-surgical procedures. As one of Hyderabad’s leading healthcare providers, we are committed to delivering exceptional care with compassion, expertise, and precision.',
        imageURL: GeneralMedicine1,
        points: [
          'Diagnostic Procedures & Lab Tests',
          'Medications',
          'Preventive Healthcare & Immunization',
          'Chronic Disease Management',
          'Emergency Care',
          'Minor Medical Procedures'
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions our Physicians treat at MagnAid Hospital',
        paragraph: [
          'Our physicians are well-experienced in effectively handling various health conditions through non-surgical procedures in adults like -',
          'MagnAid Hospital is one of Hyderabad’s top healthcare providers equipped with skilled physicians to treat all of your health issues with the utmost care'
        ],
        points: [
          'Respiratory Conditions',
          'Cardiovascular Disorders',
          'Endocrine and Metabolic Disorders',
          'Digestive Issues',
          'Kidney and Urinary Tract Diseases',
          'General Checkups/Preventive Healthcare'
        ],
        images: [GeneralMedicine2, GeneralMedicine3]
      },
      galance: {
        title: 'Excellence in General Medicine',
        content: [
          'Get expert care from an experienced specialist at MagnAid Hospital for a wide range of health conditions',
          'Get diagnosed with the latest technologies powered by AI',
          'Consultation is available from the comfort of your home.',
          'Get the medicines prescribed through call.',
          'Get the personalised treatments curated according to your needs.',
          'Manage chronic diseases with our early diagnosis.'
        ]
      },
      latestTecTitle: "Latest Technologies ",

      tools: [
        'AI-powered machines',
        'Telemedicine',
        'Virtual diagnosis',
        'Portable Ultrasound devices',
        'Digital Xrays and CT Scans',
        'Smart sensors in medical devices',
        'Point of care testing (PCOT)'
      ],
      Faq: [
        {
          question: 'What conditions do general medicine doctors treat?',
          answer: 'General medicine doctors also called general physicians are able to treat a wide range of health issues, including infections, respiratory problems, digestive disorders, heart disease, diabetes, and hypertension.'
        },
        {
          question: 'When should I see a general medicine doctor?',
          answer: 'You can consider visiting the General physician when you experience symptoms like fever, cough, fatigue, digestive issues, or need regular health check-ups and chronic disease management.'
        },
        {
          question: 'How often should I visit a general medicine doctor?',
          answer: 'It is always recommended to have annual regular check-ups and consult whenever you experience any of the symptoms mentioned above.'
        },
        {
          question: 'Do I need an appointment to see a general medicine doctor?',
          answer: 'Although there is no need for an appointment for walk-ins but would recommend you to book an appointment to reduce wait times.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Physicians at MagnAid Hospital',
        Doctors: [
          {
            photo: swethaD,
            doctorName: 'Dr. Swetha Damacharla',
            profession: 'Internal Medicine & Diabetologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Harish Kumar.J',
            profession: ' General Medicine & Diabetologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Pradeep Reddy',
            profession: 'Consultant Physician & Diabetologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Samyukta Reddy . V',
            profession: 'Consultant  Internal Medicine'
          }
        ]
      }
    },
    {
      title: 'Pulmonology',
      Icon: pulmoIcon,
      aboutTitle: "What is Pulmonology?",
      metaTitle: "Best Pulmonology Hospital in Hyderabad | Magnaid Hospital",
      metaDescription: "Best lung hospital in Hyderabad, MagnAid Hospitals offers expert pulmonology care for respiratory issues. Top pulmonologists ensure your health and well-being.",
      metaUrl: "best-pulmonology-hospital-hyderabad",
      description: 'Expert care for lung diseases, including asthma, COPD, and respiratory infections.',
      cardDes: 'Skilled and Expert pulmonologists who are offering advanced treatments for your lung health, breathing, and respiratory wellness.',
      about: [
        'Pulmonology is a medical specialty that deals with diseases involving the respiratory tract and the lungs. It is also known as Respiratory medicine or Chest medicine.',
        'Our team of expert pulmonologists at MagnAid Hospital are skilled enough to treat and cure any conditions from the common cold to severe lung disorders like - asthma, COPD, pneumonia, lung infections, and other breathing disorders.',
        'Our Pulmonologists will ensure optimal respiratory health even if the condition is complex with advanced technologies.'
      ], latestTecTitle: "Latest Technologies ",

      image: pulmonology,
      procedures: {
        title: "Treatments and Procedures",
        description: 'The department of Pulmonology at MagnAid Hospitals provides complete treatment for various Lung disorders like COPD, Asthma, ILDs, Tuberculosis, Pneumonias, Bronchiectasis,  Pneumothorax, Pleural effusion, Pulmonary embolism, Swine flu(H1N1), COVID19, ARDS, Lung malignancies, CTDs, CVDs, Sleep disorders like OSA, OHS and also Allergic diseases. Best treatment options can be availed through our OP, IP and ICU services. Our centre also offers latest Interventional Pulmonology procedures like Bronchoscopy, Thoracoscopy, Rigid Bronchoscopy, Foreign body removal, ICD placement, Thoracocentesis etc. and advanced tests like Allergy testing, Sleep study and Pulmonary function test. Treatment for Allergic diseases with latest modalities like Immunotherapy and Biologics is also available . At MagnAid Hospitals, we believe in practicing evidence based medicine and follow recent advances in the field of Pulmonology. We are enthusiastic and passionate about our work and strive to provide the best patient care.',
        imageURL: pulmo_img_1,
        points: [
          'PFTs (Pulmonary Function Test)',
          'CT Scan & X ray of the chest',
          'Lung biopsy',
          'Spirometry',
          'Lung Diffusion Capacity',
          'Impulse Oscillometry',
          'Treatment plans'
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions our Pulmonologists treat at MagnAid Hospital',
        paragraph: ['No matter if you are dealing with a common cough or you are having difficulty breathing or any other complex breathing issues, our skilled pulmonologists from MagnAid Hospital got you a cover.'],
        images: [pulmo_img_2, pulmo_img_3],
        experties: {
          title: "Expertise",
          points: [
            'Asthma',
            'Allergy',
            "COVID 19",
            'Pneumonia',
            'Lung Cancer',
            'Lung Abscess',
            "Pneumothorax",
            'Bronchiectasis',
            "Sleep Disorders",
            "Swine Flu (H1N1)",
            'Acute Bronchitis',
            'Pleural Effusion',
            'Tuberculosis (TB)',
            'Common Cold & Flu',
            'Pulmonary Fibrosis',
            "Pulmonary Embolism",
            'Respiratory Failure',
            'Pulmonary Hypertension',
            "Connective Tissue Disorder",
            'Occupational Lung Diseases',
            "Collagen Vascular Diseases",
            'Pneumothorax (Collapsed Lung)',
            'Interstitial Lung Disease (ILDs)',
            'Chronic Obstructive Pulmonary Disease (COPD)',
          ],
        },
        servicecOffered: {
          title: "Services Offered",
          points: [
            "Bronchoscopy",
            "Thoracoscopy",
            "ICD Placement",
            "Thoracocentisis",
            "Rigid Bronchoscopy",
            "Foreign Body Removal",
            "Allergy Testing",
            "Sleep Study",
            "Pulmonary Function Test",

          ]
        }

      },
      galance: {
        title: 'Excellece in Pulmonology',
        content: [
          'Treat your Lung and respiratory diseases with our expert Pulmonologists.',
          'Find the expert Pulmonologists at MagnAid hospital with advanced technologies',
          'Effective treatment is available for common cold to severe lung disorders like lung cancer.',
          'Get the initial screening and diagnosis with state-of-the-art technologies.',
          'Virtual consultation and remote monitoring are made available at your fingertips.'
        ]
      },
      tools: [
        'AI Integrated spirometry',
        'ENB (Electromagnetic Navigation Bronchoscopy)',
        'Ultrasound of lungs',
        'Caonography',
        'Remote patient monitoring',
        'Robotic-Assisted Bronchoscopy',
        'Respiratory ICU',
        'Home ventilation service (BIPAP, CPAP)'
      ],
      Faq: [
        {
          question: 'When should I see a pulmonologist?',
          answer: 'When you experience continuous cough or shortness of breath and symptoms like breathing difficulties then a pulmonologist will treat the conditions.'
        },
        {
          question: 'Can a pulmonologist diagnose sleep disorders?',
          answer: 'Yes, a pulmonologist can effectively detect sleep disorders by examining breathing patterns.'
        },
        {
          question: 'Can pulmonologists treat lung cancer?',
          answer: 'Yes, they can treat lung cancer by collaborating with our in-house oncologists to create a personalised treatment plan.'
        },
        {
          question: 'How often should I follow up with my pulmonologist?',
          answer: 'Follow-ups depend on your condition. Chronic illnesses like COPD or asthma will require regular visits as prescribed by their pulmonologists.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Pulmonologists at MagnAid Hospital',
        Doctors: [
          {
            photo: mahendra,
            doctorName: 'Dr. Mahendra Biradar',
            profession: 'Pulmonologists'
          }
        ]
      }
    },
    {
      title: 'Pediatrics',
      Icon: pedeiatrics,
      aboutTitle: "What is Pediatrics?",
      metaTitle: "Best Pediatric hospitals in Hyderabad | Magnaid Hospitals",
      metaDescription: "MagnAid Hospitals is one of the best pediatric hospitals in Hyderabad, offering expert care with the best pediatrician in Hyderabad. Book an appointment today.",
      metaUrl: "best-pediatrics-hospitals",
      description: 'MagnAid Hospitals is one of the best pediatric hospitals in Hyderabad, offering expert care with the best pediatrician in Hyderabad. Book an appointment today.',
      cardDes: 'Trust the expert care and ensure your child’s growth, development, overall health and well-being from infants to toddlers.',
      about: [
        'Pediatrics is a branch of medical science focused on the treatment of infants, children, and teenagers, typically up to the age of 18.',
        'Pediatricians diagnose and treat health conditions by closely monitoring a child’s development, providing preventive care through vaccinations, and offering comprehensive nutrition plans for overall growth and well-being.',
        'At MagnAid Hospital, our pediatricians are committed to promoting healthy development and ensuring the overall well-being of children.'
      ], latestTecTitle: "Latest Technologies ",

      image: pedia_img_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Paediatricians at MagnAid Hospital closely monitor and examine each child’s health to create personalized treatment plans. Below are the treatments and procedures our paediatricians follow:',
        imageURL: treatmentFollowed,
        points: [
          'Physical examination with routine checkups',
          'Screening tests to evaluate development',
          'Lab tests',
          'Timely vaccinations',
          'Medications',
          'Nutritional care',
          'Counselling for trauma, anxiety, and depression'
        ],
        bottomLine: 'And much more. Trust MagnAid Hospital for your child’s healthy growth and development.'
      },
      conditionsTreat: {
        heading: 'Conditions our Pediatricians treat at MagnAid Hospital',
        paragraph: [
          'Our Pediatricians provide a wide range of care to the children who are suffering from either the common illness or dealing with complex health issues. Our expert paediatricians provide specialised treatment with utmost care no matter what the issue is.',
          'MagnAid Hospital’s expert Pediatricians are highly skilled in addressing the following range of health issues among children:'
        ],
        points: [
          'Common cold, flu and fever',
          'High fever',
          'Certain allergies',
          'Vaccinations',
          'Ear, nose and throat infections',
          'Delayed growth',
          'Delay in speech and learning',
          'Diabetes in young ones',
          'Genetic disorders',
          'Epilepsy',
          'Various infectious diseases',
          'Malnutrition and Obesity',
          'Injuries',
          'Anxiety, Depression and Trauma'
        ],
        images: [pedia_img_2, pedia_img_3]
      },
      galance: {
        title: 'Excellence in Pediatrics',
        content: [
          'Pediatrics is a medical branch dealing with the wellness of infants and children till 18 years of age.',
          'Paediatricians are the professionals to monitor the health, growth and development of the children ensuring their wellness.',
          'They treat your kid’s common conditions like flu or cold to cure complex health conditions like diabetes and mental issues.',
          'With advanced technologies like ECMO and CGMs, paediatricians will be able to precisely treat any of your child’s health issues.'
        ]
      },

      tools: [
        'Digital stethoscope',
        'AI-powered diagnostic tools',
        'Ultrasound technology',
        'CGMs for diabetic children',
        'Nebulizers',
        'ECMO and Phototherapy units',
        'NICU and PICU care units'
      ],
      Faq: [
        {
          question: 'When should I schedule my child’s first doctor visit?',
          answer: 'The first visit to a pediatrician should be scheduled within one week of the baby’s birth, followed by regular checkups as recommended.'
        },
        {
          question: 'Is it normal for children to have frequent colds?',
          answer: 'Yes, it’s common for young children to catch colds frequently, but you should seek medical attention if the condition worsens or persists.'
        },
        {
          question: 'Can I consult a paediatrician for my child’s mental health concerns?',
          answer: 'Yes, our paediatricians at MagnAid Hospital provide counselling and therapies to support your child’s mental health.'
        },
        {
          question: 'Is teleconsultation available for pediatric care?',
          answer: 'Yes, MagnAid Hospital offers teleconsultation services with our top paediatricians for your child’s care.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Pediatricians at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Rajshekar Reddy',
            profession: 'Pediatrician'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Shilpa Reddy Tummala',
            profession: 'Pediatrician'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Srikant Marda',
            profession: 'Pediatrician'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Vannala Raju',
            profession: 'Pediatrician'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Srikanth Cheryala',
            profession: 'Pediatrician'
          }
        ]
      }
    },
    {
      title: 'Critical Care',
      Icon: crticalIcon, aboutTitle: "What is Critical Care?",
      metaTitle: "Best ambulance service in hyderabad | Magnaid Hospitals ",
      metaDescription: "MagnAid Hospitals offers 24/7 emergency services, ambulance service in Hyderabad, and expert care in our hospital emergency department for urgent medical needs.",
      metaUrl: "critical-care-medicine",
      description: 'Immediate medical care for critically ill or injured patients.',
      cardDes: 'With advanced treatment get intensive care with expert monitoring & support during life-threatening conditions and critically ill patients.',
      about: [
        'Critical care and Emergency medicine is the branch which deals with the treatment of patients who have met with life-threatening situations.',
        'Critical care is a unit at MagnAid hospital where intensive care is provided to critically ill patients by keeping them in the ICU and continuously monitoring their conditions with advanced technologies.',
        'Emergency medicine is the unit which deals with giving emergency treatments to patients who suffered cardiac arrest, respiratory failure or met with an accident by thorough diagnosis.'
      ], latestTecTitle: "Latest Technologies ",

      image: critical_img_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Our emergency medicine department is open 24/7 throughout the year making the accessible to patients during their critical conditions. Our doctors treat the patients compassionately making their recovery journey more easy. Doctors at MagnAid Hospital prefer following specialised treatments and procedures to manage complicated situations-',
        imageURL: critical_img_2,
        points: [
          'Electric shocks through Defibrillation',
          'Advanced Airway Management and CPR',
          'Emergency Fracture and Dislocation Management',
          'Emergency medications for pain relief',
          'Blood transfusion for severe blood loss',
          'Advanced ventilation',
          'Real-time monitoring with advanced machines',
          'Surgical procedures',
          'Dialysis'
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'What are the conditions we treat in Critical care and Emergency medicine?',
        paragraph: ['Our doctors at MagnAid Hospital in critical care and Emergency medicine are skilled in handling a vast range of conditions from acute injuries to treating life-threatening conditions like-'],
        points: [
          'Accidents',
          'Toxic exposures like poisoning',
          'High fever and sudden unconsciousness',
          'Sudden stroke',
          'Injuries due to burn or fracture',
          'Heart attack or chest pain',
          'Respiratory, Kidney, Liver or heart failure',
          'Severe bleeding'
        ],
        images: [critical_img_3, critical_img_4]
      },
      galance: {
        title: 'Excellence in Critical Care',
        content: [
          'Intensive care for critically ill patients with the facilities of continuous monitoring and advanced technologies in the ICU.',
          'Get treated effectively during emergency conditions like cardiac arrest or severe accidents.',
          'Your common conditions like injuries, high fever, and fractures are treated by skilled doctors of MagnAid hospitals.',
          'For any emergency condition, MagnAid Hospital is open 24/7 equipped with professional doctors for everyone.',
          'You can trust MagnAid Hospital during those emergency and critical situations because of various advanced machines and equipment for precise treatment.'
        ]
      },
      tools: [
        'Portable and Point-of-care Ultrasound',
        'Continuous Renal Replacement Therapy',
        'High-Frequency Ventilators',
        'Smart Defibrillators',
        'Video Laryngoscopy',
        'Pulse oximeter',
        'BiPAP (Bi-Level Positive Air Pressure)'
      ],
      Faq: [
        {
          question: 'When should I visit the emergency department?',
          answer: 'If you or any other person experiences severe chest pain, difficulty in breathing, sudden unconsciousness or severe injuries.'
        },
        {
          question: 'What types of tests are done in an emergency?',
          answer: 'Based on the situation and severity of the patient, the doctor may carry out blood tests, CT scans, MRIs and other tests for precise diagnosis.'
        },
        {
          question: 'What treatments are available for severe injuries or accidents?',
          answer: 'Based on the patient’s condition, our doctors may perform surgeries, give pain relief medications or blood transfusion'
        },
        {
          question: 'How does the hospital ensure patient safety in critical care?',
          answer: 'Hospitals use strict infection control, continuous monitoring, and advanced technologies to ensure patient safety and care quality.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Critical and Emergency Care Unit at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Pavan Kumar Reddy. N',
            profession: 'Critical and Emergency Care Unit'
          },
          {
            photo: drsvg,
            doctorName: 'Dr CH Hanumantha Rao',
            profession: 'Critical and Emergency Care Unit'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Kaladhar. S',
            profession: 'Critical and Emergency Care Unit'
          }
        ]
      }
    },
    {
      title: 'Anaesthesia',
      Icon: anesthetia, aboutTitle: "What is Anaesthesia?",

      metaTitle: "Anesthesia and Pain Management | Epione Pain Management",
      metaDescription: "Experience relief with Anaesthesia & Pain Management specialists at MagnAid Hospitals. Our expert consultations and services ensure comfort and pain-free living.",
      metaUrl: "anesthesia-and-pain-management",
      description: 'Advanced pain relief and sedation techniques for surgeries and chronic conditions.',
      cardDes: 'Providing safety and personalized relief in all invasive procedures with advanced anaesthesia and pain management.',
      about: [
        'Anesthesia is a medication which is used during the medical procedures. Anaesthesia pain management is a specialised branch in the medical field which is carried out by professional anesthesiologists to manage and relieve pain during surgeries.',
        'This method is carried out in several ways like blocking the nerve, through tablets or injections, or some other methods to bring comfort to the patients during the pain. Anesthesiologists ensure the patient’s safety by comforting them from pain by personalised treatment plans.'
      ], latestTecTitle: "Latest Technologies ",

      image: anesthe_img_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Our professional Anesthesiologists follow guided rules while performing anaesthesia or any pain management procedure to ensure the safety of patients.',
        imageURL: anesthe_img_2,
        points: [
          'General Anesthesia is given for the unconscious in major surgery',
          'Through regional anaesthesia, only a particular area is made numb',
          'Through Monitored Anesthesia Care, the patient is awake during the surgery',
          'With local anesthesia only a small portion is made numb.'
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions treated by the professional anesthesiologists at MagnAid Hospital',
        paragraph: ['Our professional anesthesiologists treat a wide range of conditions related to pain and ensure the safety of the patients without causing them any side effects from the dose.'],
        points: [
          'Painless experience during Surgeries.',
          'Pain management post-surgery.',
          'Treats long-term Chronic pain',
          'Relieves pain caused by cancer treatments.',
          'Manages moderate pain',
          'Relieves from pain during pregnancy, labor pain or childbirth.',
          'Treats chronic pain like severe headaches',
          'Treats severe nerve pain'
        ],
        images: [anesthe_img_3, anesthe_img_4]
      },
      galance: {
        title: 'Excellence in Anesthesia Pain Management ',
        content: [
          'Anesthesia pain management is a medical procedure carried out only by a professional anesthesiologist at MagnAid Hospital.',
          'Our Anesthesiologists follow proper guidelines to ensure patient safety.',
          'They treat various ranges of pain. Even if it’s during the surgery or post-surgery.',
          'Anesthesiologists at MagnAid Hospital curate the pain management plans according to the patient’s needs.',
          'They follow different types of anaesthesia depending on the patient’s condition.'
        ]
      },
      tools: [
        'Anesthesia Machines',
        'Nerve Block Needles',
        'Patient Monitoring Systems',
        'Infusion Pumps',
        'Ultrasound for Regional Anesthesia'
      ],
      Faq: [
        {
          question: 'Is anesthesia safe?',
          answer: 'Anaesthesia is generally safe. However, your anesthesiologists will evaluate your medical history for any possible complications.'
        },
        {
          question: 'What if I have allergies to anaesthesia?',
          answer: 'In that case, you will have to let your anesthesiologists know about it and they will find the right option for you.'
        },
        {
          question: 'Can anaesthesia cause side effects?',
          answer: 'Mild side effects like nausea and dizziness, are common. You will be closely monitored to be protected from any severe complications which are usually rare.'
        },
        {
          question: 'Will I feel anything during anaesthesia?',
          answer: 'You will usually not feel or even remember anything under general anesthesia but you will be awake during regional anesthesia.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Anesthesiologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Anil Gupta',
            profession: 'Anesthesiologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Neha Sharma',
            profession: 'Anesthesiologist'
          }
        ]
      }
    },
    {
      title: 'Cardiology',
      Icon: cardioIcon, aboutTitle: "What is Cardiology?",

      metaTitle: "Best Cardiologist Hospital in Hyderabad | Magnaid Hospitals",
      metaDescription: "MagnAid Hospitals is a top cardiology hospital in Hyderabad, with the best heart specialist in Hyderabad, offering expert care for all heart conditions now.",
      metaUrl: "cardiology-hospitals-in-hyderabad",
      description: 'Advanced heart care for conditions like hypertension, heart attacks, and arrhythmias.',
      cardDes: 'Experience personalized heart care, advanced treatments, and solutions for optimal cardiovascular health with our expert cardiologist.',
      about: [
        'Cardiology is the medical field that deals with the diagnosis and treatment of illnesses and diseases related to the heart and blood vessels.',
        'Our professional Cardiologists at MagnAid Hospital specialise in managing various conditions like heart attacks, stroke, heart diseases and other cardiovascular issues. With the use of advanced technologies,  our cardiologists ensure proper heart health by providing preventive measures to reduce the diseases related to the heart.',

      ],
      image: cardio_img_2,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Based on the patient’s heart health and condition, cardiologists carry out various kinds of procedures like surgical, non-surgical, early diagnosis and emergency treatments like-',
        imageURL: cardio_img_1,
        points: [
          'MRI and CT Scan of the heart',
          'ECG or EKG to record heart activity',
          'Holter monitoring & Defibrillation',
          'Heart or valve replacement',
          'Implantation of pacemaker or ICD',
          'Coronary and Peripheral Angiography', "Stress test and management",
          "Non surgical treatments through medications, lifestyle changes and rehabilitation"
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions our Cardiologists treat at MagnAid Hospital',
        paragraph: ['Our expert cardiologists manage a variety of heart-related conditions with advanced care and technology.'],
        points: [
          'Cholesterol',
          "Cardiac arrest", "Heart transplantation",
          'Heart palpitations',
          'High blood pressure and Hypertension',
          'Inflammation in heart',
          'Heart failures & Stroke',
          "Disease in artery",
          'Irregular heartbeats', "Defects in heart or heart disorders",
        ],
        images: [cardio_img_3, cardio_img_4]
      },
      galance: {
        title: 'Excellence in Cardiology',
        content: [
          'Cardiology is a medical branch dealing with the treatment of heart health and blood vessel diseases.',
          'Professional cardiologists at MagnAid Hospital treat illnesses like cholesterol, heart diseases and cardiovascular disorders.',
          'Cardiologists treat all heart-related diseases with advanced equipment for faster recovery ensuring patient comfort.',

        ]
      },
      latestTecTitle: "Latest Technologies ",

      tools: [
        'ECG analysis with AI-powered',
        'Real-time heart monitor ',
        'Heart surgeries carried through robotic assistance',
        'Intravascular ultrasound',
        'Cathlabs',
      ],
      Faq: [
        {
          question: 'When should I see a cardiologist?',
          answer: 'When you experience pain in your chest, shortness of breath or there is any history of heart disease running in your family then you must visit a cardiologist.'
        },
        {
          question: 'Is a heart attack the same as cardiac arrest?',
          answer: 'Both of these conditions are different. Due to blockages in the blood flow, a heart attack is caused and when the heart suddenly stops beating, it is a cardiac arrest.'
        },
        {
          question: 'Can children see a cardiologist?',
          answer: 'At MagnAid Hospital,  we have a team of expert pediatric cardiologists who are experienced in treating heart conditions among infants and children.'
        },
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Cardiologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Jagadesh Madireddi',
            profession: 'Cardiologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Saketh E',
            profession: 'Cardiologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr N Dhananjaneya Reddy',
            profession: 'Cardiologist'
          },
        ]
      }
    },
    {
      title: 'Dermatology',
      Icon: DermotologyIcon, aboutTitle: "What is Dermatology?",

      metaTitle: "Best Skin Treatment Hospital in Hyderabad | MagnAid Hospitals",
      metaDescription: "MagnAid Hospitals is the best hospital for skin treatment in Hyderabad, offering expert dermatologist services and care from the skin specialist in Hyderabad.",
      metaUrl: "best-dermatologist-in-hyderabad",
      description: 'Expert care for skin diseases and cosmetic treatments.',
      cardDes: 'Achieve healthy and clear skin through effective treatments and expert dermatologist’s advice that boost your confidence.',
      about: [
        'Dermatology is the branch of medical science which deals with the treatment of various diseases and conditions related to skin, hair and nails.',
        'Dermatologists are the experts and professionals in the field who effectively treat the conditions related to the skin, hair and nails and help in enhancing the overall skin health.'
      ],
      image: dermi_img_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'To address all of your issues related to skin, hair and nails, Dermatologists of MagnAid hospital follow the following procedures and treatments-',
        imageURL: dermi_img_2,
        points: [
          'Serology',
          'PCR tests',
          'Surgical procedures',
          'Light therapy using phototherapy',
          'Cryotherapy to remove warts or moles',
          'Laser treatment for various skin disorders',
          "Skin biopsy and Allergy tests to diagnose the skin condition",
          "Medications like creams, injections or medicines to treat infections"
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Dermatologists at MagnAid Hospital',
        paragraph: ['Skin covers the major portion of your body and it deserves the best care possible. At MagnAid Hospital, our expert dermatologists will effectively solve all your concerns related to skin hairs and nails-'],
        points: ['Any kind of fungal infections',

          'Pigmentation issues',
          "Problem of acne, eczema or psoriasis", "Any kind of skin infections and rashes",
          'Treats nail disorders',
          'Issues related to scalp and hair loss',
          'Removal of moles, warts or cysts',
          'Spots on the skin',
        ],
        images: [dermi_img_3, dermi_img_4]
      },
      galance: {
        title: 'Excellence in Dermatology',
        content: [
          "We follow proper guidelines to treat the conditions by providing patient's safety.",
          'We use advanced technologies for the treatment to provide enhanced results.',
          'Along with the treatments, our dermatologists give personalised plans according to your needs.',
        ]
      }, latestTecTitle: "Latest Technologies ",

      tools: [
        ' Electrolysis',
        'Laser phototherapy',
        'Red light photodynamic therapy',
        'Laser therapy to treat skin conditions and hair removal',
      ],
      Faq: [
        {
          question: 'How do I know if I need to see a dermatologist?',
          answer: 'If the skin issues are troubling you and see excessive hair loss then it is recommended to consult a dermatologist.'
        },
        {
          question: ' How long will it take to see the results of my treatment?',
          answer: 'Results usually vary from person to person depending on the condition and treatment recommended. It will take about a week to a few months to see the visible results.'
        },
        {
          question: 'How often should I get a skin check?',
          answer: 'It is ideal to get your skin checked annually especially when there is a family history of skin diseases or you are constantly exposed to the sun.'
        },
        {
          question: 'Will medication for skin conditions cause any side effects?',
          answer: "There are some medications and procedures that may cause mild reactions like irritation, and redness around sensitive areas. But with proper care from our dermatologists, it won't last long."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Dermatologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: ' Dr. J Akshitha Reddy',
            profession: 'Dermatologist'
          },
          {
            photo: drsvg,
            doctorName: ' Dr. Rajashekhar Meeniga',
            profession: 'Dermatologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Keerthi Sidda',
            profession: 'Dermatologist'
          },
        ]
      }
    },
    {
      title: 'Psychiatry',
      Icon: Psychiatry, aboutTitle: "What is Psychiatry?",

      metaTitle: "Best Psychiatric Hospitals and Psychiatrists in Hyderabad",
      metaDescription: "MagnAid Hospitals offers the best therapy for anxiety and depression with expert care at the top psychiatric hospitals in Hyderabad. Book your consult today!",
      metaUrl: "best-psychiatrist-in-hyderabad",
      description: 'Mental health care for anxiety, depression, and psychiatric disorders.',
      cardDes: 'Offering dedicated care and emotional support for your mental well-being with personalised counselling, therapy and treatment.',
      about: [
        'Psychiatry is a branch of medical science which deals with the diagnosis and treatment of mental and behavioural disorders.',
        'Professionals who examine mental health conditions are called Psychiatrists who ensure the mental well-being of their patients by offering personalized treatment plans through managing stress, depression, anxiety and other challenges they deal with regarding mental and behavioural health.'
        , "The goal of our Psychiatrists at MagnAid Hospital is to ensure proper mental well-being and improve the patient’s overall quality of life."
      ],
      image: psyc_img_3,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Psychiatrists of MagnAid Hospital closely monitor the condition of their patients very closely in order to curate treatment plans suitable for every patient according to their needs. Following are the treatments and procedures our psychiatrists follow-',
        imageURL: psyc_img_2,
        points: [
          'Counselling sessions',
          'Behavioural therapy',
          'Rehabilitation Programs',
          'Medications for certain conditions and symptoms',
          'Electroconvulsive Therapy for severe depression',
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Psychiatrists at MagnAid Hospital',
        paragraph: ['Our Psychiatrists ensure the patients who are facing various challenges related to their mental health no matter if it’s simple concerns related to emotions to any compels psychiatric disorders. At MagnAid Hospital, our expert psychiatrists offer personalised treatment with empathy so that every patient receives the best possible support and care.', 'MagnAid Hospital is equipped with expert Psychiatrists who are highly skilled in addressing the following range of mental health issues-'],
        points: [
          'Bipolar disorder',
          'Personality disorder',
          'Past traumas',
          'Excessive Stress ',
          "Addiction to Drugs and substances",
          'Sleep disorder',
          "Anxiety or Depression",
          "Panic attacks",
          "Psychotic disorders",
          'Obsessive-Compulsive Disorder (OCD)'
        ],
        images: [psyc_img_1, psyc_img_4]
      },
      galance: {
        title: 'Excellence in Psychiatry ',
        content: [
          'Psychiatrists are professionals who are skilled in offering personalised treatments to ensure the mental well-being of their patients.',
          'Our psychiatrists offer various treatments based on individual needs from counselling to medications and advanced treatments.',
          'To provide more accurate and precise diagnoses, various cutting-edge technologies are used by our psychiatrists.',
          'Our psychiatrists are dedicated and supportive enough to make their patients feel comfortable and provide personalised care.'
        ]
      }, latestTecTitle: "Latest Technologies ",
      tools: [
        'Electroconvulsive Therapy',
        "Rehabilitation Programs",
        'Transcranial Magnetic Stimulation',
        'Genetic tests to prescribe the medications',
        'Virtual consultations and therapy',

      ],
      Faq: [
        {
          question: 'How do I know if I need to see a psychiatrist?',
          answer: 'If you are experiencing constant sadness, sudden mood swings, or if it is getting difficult to manage stress then you need to see a psychiatrist.'
        },
        {
          question: 'Are psychiatric treatments confidential?',
          answer: ' Definitely yes, all of your sessions with our psychiatrists are highly confidential ensuring your privacy and making you comfortable to to express your emotions and feelings.'
        },
        {
          question: 'How long does psychiatric treatment usually last?',
          answer: 't completely depends upon your conditions. Some treatments require short-term therapy while others will benefit from long-term therapies and counselling.'
        },
        {
          question: 'What if I’m unhappy with my current treatment?',
          answer: 'You have all the right to discuss and give feedback about your treatments. Your psychiatrists will adjust the plan based on your needs.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Psychiatrists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. V. Sravan Reddy',
            profession: 'Psychiatrist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Potluri Sindhuri',
            profession: 'Psychiatrist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. P Krishna Chaitnya',
            profession: 'Psychiatrist'
          },
        ]
      }
    },
    {
      title: 'Neurology',
      Icon: neurology, aboutTitle: "What is Neurology?",

      metaTitle: "Best Neuro Hospitals and Neurology Department in Hyderabad",
      metaDescription: "Get expert neurology services at Magnaid Hospitals, one of the top neuro hospitals in Hyderabad. Consult the best neurologists for advanced brain and nerve care",
      metaUrl: "neurologist-in-hyderabad",
      description: 'Diagnosis and treatment of brain and nervous system disorders.',
      cardDes: 'Expert care for the brain, spine and nervous system with specialized neurological services and under the guidance of expert neurologists.',
      about: [
        'Neurology is a branch of medical science which deals with the diagnosis and treatment of diseases and disorders related to the brain, nervous system and spinal cord.',
        "Professionals who specialise in the treatment of various neurological conditions are called Neurologists. They effectively diagnose and examine the symptoms and provide personalized treatment plans by ensuring the proper functioning of the nervous system.",
        "Our Neurologists at MagnAid Hospital are dedicated to providing enhanced care to maintain the overall wellness of their patients"
      ],
      image: neuro_img_2,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Neurologists at MagnAid Hospital provide personalised care by carefully diagnosing the condition of each patient. Following are the treatments and procedures our neurologists follow-',
        imageURL: neuro_img_4,
        points: [
          'Initial screening examination',
          'MRI and CT Scans',
          'Psychological therapy',
          'Pain Management Therapies',
          "Multiple sclerosis",
          'Medications to manage certain conditions',
          'Electroencephalography and Electromyography',
          "Neurointensive Care Unit for neurological emergencies",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Neurologists at MagnAid Hospital',
        paragraph: ['No matter if you are dealing with common neurological symptoms or if it is a complicated condition, our neurologists at MagnAid Hospital provide the best care possible while ensuring the comfort of their patients.', 'Our expert Neurologists at MagnAid Hospital treat the following range of conditions with utmost care-'],
        points: [
          'Migraine',
          'Tumors', "Severe Headache",
          'Brain disorders',
          'Pain Management Therapies',
          "Memory disorders",
          'Various sleep disorders',
          'Parkinson’s Disease',
          "Treat the Stroke conditions",
        ],
        images: [neuro_img_1, neuro_img_3]
      },
      galance: {
        title: 'Excellence in Neurology',
        content: [
          'Neurology is a medical branch which deals with the study of the human nervous system, brain and spinal cord.',
          'Neurologists of MagnAid Hospital treat a wide range of conditions from headaches to complex diseases like Parkinson’s disease.',
          'Our neurologists provide effective treatment plans based on the symptoms and conditions to effectively manage them.',
          'MagnAid Hospital is equipped with modern and latest technologies to provide precise diagnosis results for specialised treatment.'
        ]
      }, latestTecTitle: "Latest Technologies ",

      tools: [
        'High-resolution MRI and CT Scan',
        'AI-integrated EEG',
        'Advanced diagnostic tools',
        'Transcranial Magnetic Stimulation for neurological disorders',
      ],
      Faq: [
        {
          question: "What symptoms need a neurologist's assistance?",
          answer: 'When you experience severe and frequent headaches, dizziness, memory loss or difficulty with coordination, then a neurological examination is recommended to prevent complex conditions.'
        },
        {
          question: 'Is neurology treatment painful?',
          answer: 'Tests include EEG, MRI, CT scans, and nerve studies.'
        },
        {
          question: 'Can neurological issues affect mental health?',
          answer: 'In some cases, when the symptoms are left unnoticed then it may lead to depression, anxiety and memory loss. However, our neurologists provide effective and specialised treatment plans.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Neurologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Mohan Krishna',
            profession: 'Neurologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Chakradhar Reddy. N',
            profession: 'Neurologist'
          }
        ]
      }
    },
    {
      title: 'Radiology',
      Icon: radiology,
      aboutTitle: "What is Radiology?",

      metaTitle: "Best Radiology Hospital in Hyderabad | Magnaid Hospital",
      metaDescription: "MagnAid Hospitals is one of the best radiology hospitals in Hyderabad, offering expert radiologists and clinical imaging services like MRI, CT scan, and more.",
      metaUrl: "radiology",
      description: 'Advanced imaging services for diagnosis and treatment planning.',
      cardDes: 'Get accurate and precise diagnostic test results for your treatment with our advanced radiology services and expert care.',
      about: [
        'Radiology is that branch in the medical field which makes use of imaging technology to diagnose the presence of various conditions in the body for their treatment.',
        'Radiologists are the professionals who can read those medical images produced through X-rays, CT Scans, MRIs or Ultrasounds. They are able to provide accurate results of the diagnosis and recommend the required treatments.',
        "Radiologists at MagnAid Hospital are dedicated and ensure the accurate diagnosis to provide the best possible treatment plan for the patients using advanced technologies."
      ],
      image: radio_img_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'To accurately treat the various health conditions our Radiologists at MagnAid Hospital use advanced imaging technologies to diagnose and address the issues of patients effectively. Following are the  various treatments and procedures our Radiologists follow-',
        imageURL: radio_img_4,
        points: [
          'Ultrasound',
          'PET Scans to detect cancer',
          'X-rays to detect fractures',
          'CT scanning and MRI for internal screenings',
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Diagnosed by Radiologists at MagnAid Hospital',
        paragraph: [
          'Our Radiologists at MagnAid Hospital diagnose a wide range of medical conditions accurately. They ensure the proper treatment is provided to the patients irrespective of any condition, be it simpler or complicated.',
          "", "",
        ],
        points: [
          'Internal injuries',
          'Fractures',
          'Abnormalities in brain',
          "Cancer",
          'Disorders of the digestive system',
          'Kidney disorders',
          "Reproductive issues",
          "Blockages in blood vessels",
          "Orthopaedic conditions",
          'Lung, Heart and vascular diseases',
        ],
        images: [radio_img_2, radio_img_3]
      },
      galance: {
        title: 'Excellence in Radiology',
        content: [
          'They are skilled in identifying effectively the health conditions through the images produced.',
          'Radiology is the branch of the medical field which deals with the imaging and screening of various health issues.',
          'Radiologists at the MagnAid Hospitals use advanced technologies to accurately diagnose and provide effective treatment plans.',
          'To ensure the patient’s comfort, our hospital is equipped with the latest and advanced technologies for precise diagnosis results.'
        ]
      },
      latestTecTitle: "Latest Technologies ",
      tools: [
        'Digital X-rays',
        'Advanced CT Scans',
        'AI integrated MRI',
      ],
      Faq: [
        {
          question: 'Are radiology procedures safe?',
          answer: ' We at MagnAid Hospitals use advanced and modern imaging technologies which are generally safe. In addition, our radiologists ensure the safety of patients during the procedure.'
        },
        {
          question: 'Are there any side effects of radiology scans?',
          answer: 'Usually, there are no major side effects but some mild side effects can be observed due to certain chemicals used in the CT scans or MRIs.'
        },
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Radiologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Sameer Khan',
            profession: 'Radiologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Anjali Mehta',
            profession: 'Radiologist'
          }
        ]
      }
    },
    {
      title: 'Medical Oncology',
      Icon: medicalOncology, aboutTitle: "What is Medical Oncology?",
      metaTitle: "Best Oncology and Lung Cancer Specialists in Hyderabad.",
      metaDescription: "MagnAid Hospitals' Medical Oncology Department offers expert care for lung cancer and other cancers. Our top oncologists in Hyderabad provide personalized care.",
      metaUrl: "medical-oncology",
      description: 'Cancer diagnosis and treatment using chemotherapy, immunotherapy, and targeted therapy.',
      cardDes: 'Advanced treatments for cancer patients by offering personalized treatment with emotional support throughout the process.',
      about: [
        'Medical Oncology is the medical branch which focuses on the diagnosis, treatment and management of cancer through various medications and procedures.',
        'Oncologists are professionals who are specialized in the field of medical oncology. They are a team of specialists, surgeons and radiation oncologists who work together to create a personalised treatment plan for cancer patients to provide the best possible care.',
        'At MagnAid Hospital, our oncologists are dedicated towards providing the compassionate care at every stage with advanced technologies.',
      ],
      image: ocno_img_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Our oncologists follow the procedures to treat cancer patients with utmost care by curating personalised treatment plans and effectively managing the cancer at any stage.Following are the treatments and procedures we follow at MagnAid Hospital-',
        imageURL: ocno_img_2,
        points: [
          'Chemotherapy',
          'Hormone therapy',
          "Molecular therapy",
          "Endocrine therapy",
          'Survivorship Programs',
          'Bone marrow transplantation',
          'Immunotherapy to boost the immune system',
          'Screening and Diagnostics for early cancer detection',
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Oncologists at MagnAid Hospital',
        paragraph: ['Our specialized Oncologists at MagnAid Hospital are skilled enough to provide compassionate care to patients dealing with cancer. They provide personalised treatment plans for various types of cancer.', 'Oncologists at MagnAid Hospital are skilled enough to treat various types of the following cancer at any stage-'],
        points: [
          'Benign Tumors',
          'Skin cancer',
          'Various types of cancer like- lung, liver, blood, ovarian or cervical cancer.',
          'Treats precancerous conditions',
          'Effectively diagnoses early-stage cancer',
          'Metastatic Cancer',
        ],
        images: [ocno_img_3, ocno_img_4]
      },
      galance: {
        title: 'Excellence in Medical Oncology',
        content: [
          'Oncology is a specialised branch which helps in diagnosing and treatment of cancer.',
          'They are skilled enough to treat the precancerous conditions and the cancer present at any stage.',
          'To provide effective and precise treatment, oncologists at MagnAid hospital utilise modern and state-of-the-art technologies.',
          ' Oncologists are the professionals who effectively treat cancer of any type through advanced technologies and collaborating with other specialists.'
        ]
      }, latestTecTitle: "Latest Technologies ",

      tools: [
        'Hyperthermia',
        'Brain Mapping',
        'PET-CT Scans and MRI',
        'Liquid biopsy to detect cancer',
        'Surgeries assisted by robots for precise treatment',
      ],
      Faq: [
        {
          question: 'How do I know if I need to see an oncologist?',
          answer: 'When your primary doctor detects any abnormalities, suspects lumps or sees symptoms similar to cancer then they will recommend you to the oncologists for early diagnosis.'
        },
        {
          question: 'Can I receive counselling and emotional support during treatment?',
          answer: 'At MagnAid Hospital, our oncologists treat your cancer effectively with advanced technologies along with compassionate care with timely counselling to support your mental and emotional well-being.'
        },
        {
          question: 'What are the side effects of cancer treatments?',
          answer: 'Although the side effects differ from treatment to treatment but usually patients experience fatigue, nausea and hair loss. Our Oncologists will be guiding you throughout the journey of effectively handling these changes.'
        },
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Oncologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Vishal',
            profession: 'Oncologist'
          },
        ]
      }
    },
    {
      title: 'Medical Gastroenterology',
      Icon: gastroenterology,
      aboutTitle: "What is Medical Gastroenterology?",
      metaTitle: "Best Gastroenterologist and Liver Hospital in Hyderabad",
      metaDescription: "Magnaid Hospitals offers expert care with top gastroenterologists and liver specialists in Hyderabad. Get the best treatment for liver disease and gastro issues",
      metaUrl: "best-gastroenterologist-in-hyderabad",
      description: 'Expert care for digestive system disorders and liver diseases.',
      cardDes: 'Gastroenterology services that treat all of your digestive problems and make your gut healthier with advanced diagnostics.',
      about: [
        'Gastroenterology is the field of medical science which deals with diagnosing and managing the conditions and disorders related to the digestive system including the various organs like the stomach, intestines, liver, pancreas, and gallbladder that participate in digestion.',
        'Gastroenterologists are professionals who are specialised in treating the conditions and disorders related to the digestive system and effectively managing the symptoms. They make use of the right techniques to detect the problem which may be as simple as abdominal pain and as complicated as colon cancer by providing personalized treatment plans.',
        'Gastroenterologists at MagnAid Hospital are dedicated to providing compassionate care to their patients dealing with various kinds of digestive issues and ensuring their well-being.'
      ],
      image: gen_med_1,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Our Gastroenterologists at MagnAid Hospital use advanced technologies to ensure the proper care of their patients by effectively treating various digestive issues through proper diagnosis and treatment plans.Following are the treatments and procedures they follow at MagnAid Hospital-',
        imageURL: gastro_img_1,
        points: [
          'ERCP',
          'Hepatology',
          'Medications',
          'Cancer treatments',
          'CT Scans and Ultrasound',
          'Examine the colon through Colonoscopy',
          'Diagnosis of digestive track through Endoscopy'
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Gastroenterologists at MagnAid Hospital',
        paragraph: ['Our expert Gastroenterologists at MagnAid Hospital take proper measures while treating various conditions from common to complicated related to digestive issues with utmost care.', 'Following are the range of conditions that our Gastroenterologists treat-'],
        points: [
          'Indigestion and bloating',
          'Stomach infections',
          'Constipation',
          'Acidity or Heartburn',
          'Liver infection and diseases',
          'Pancreas related problems',
          'Stomach ulcers',
          'Irritable bowel syndrome',
          'Gallstones',
          'Stomach, colon, pancreatic or liver cancer'
        ],
        images: [gastro_img_2, gastro_img_3]
      },
      galance: {
        title: 'Excellence in Gastroenterology',
        content: [
          'They ensure precise diagnosis with state-of-the-art technologies',
          'Gastroenterologists are professionals who are specialised in the treatment of conditions related to the digestive tract.',
          'Gastroenterologists at MagnAid Hospital provide personalised treatment plans using advanced technologies to ensure the patient’s wellness.',
          'Gastroenterology is a field which deals with the study and treatment of issues related to the digestive system and examining the organs involved in the digestive process like stomach, liver, intestine, and pancreas.',
        ]
      }, latestTecTitle: "Latest Technologies ",

      tools: [
        'Fibroscan',
        'Enteroscopy',
        'Digital diagnosis',
        'Capsule endoscopy',
        'Endoscopy ultrasound'
      ],
      Faq: [
        {
          question: 'Can digestive issues be managed without surgery?',
          answer: 'Surgeries are usually recommended for patients with serious digestive issues.Most of the digestive issues can be treated with medications and following the healthy lifestyle.'
        },
        {
          question: 'Why choose MagnAid Hospital for digestive care?',
          answer: 'MagnAid Hospital is equipped with the latest and state-of-the-art technologies for precise diagnosis and effective treatment for patient’s comfort and wellness.'
        },
        {
          question: 'What are the signs that I may have a serious digestive problem?',
          answer: 'Symptoms of severe digestive problems include severe abdominal pain, blood in stools, constipation, and constant acidity are some of the indicators you have a severe digestive problems.'
        },
        {
          question: ' Are digestive problems always related to diet?',
          answer: 'Although diet plays a major role in creating digestive issues, it is also caused due to infections, chronic stress and some medical conditions.'
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Gastroenterologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Suresh Reddy',
            profession: 'Gastroenterologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Kavita Nair',
            profession: 'Gastroenterologist'
          }
        ]
      }
    },
    {
      title: 'Nephrology',
      Icon: nephrology,
      aboutTitle: "What is Nephrology?",
      metaTitle: "Best Kidney Disease Treatment and Nephrologists in Hyderabad",
      metaDescription: "Magnaid Hospitals provides expert nephrologists for kidney disease treatment in Hyderabad. Get the best care at our top nephrology hospital for kidney problems.",
      metaUrl: "nephrology-hospital",
      description: 'Kidney disease management, dialysis, and transplantation care.',
      cardDes: 'Improve the functioning of your kidney and improve its health with early diagnosis and advanced and effective nephrology services.',
      about: [
        'Nephrology is a branch which deals with the diagnosis and treatment of diseases related to the kidneys.',
        'Specialist doctors who precisely diagnose and treat the issues related to the kidneys are called Nephrologists. They effectively manage various types of kidney problems.',
        'Nephrologists at MagnAid Hospital are skilled and offer compassionate care to the patients, ensuring the proper functioning of the kidneys.'
      ],
      image: nephro_img_4,
      procedures: {
        title: "Treatments and Procedures",
        description: 'Our Nephrologists at MagnAid Hospital use advanced technologies and give personalised treatment plans to the patients to treat a wide range of kidney problems. Following are the treatments and procedures followed by our Nephrologists at MagnAid Hospital.',
        imageURL: nephro_img_1,
        points: [
          'Maintains kidney failure with Dialysis',
          'Kidney transplantation',
          'Nephrectomy',
          'Ureteroscopy or Lithotripsy',
          'Kidney biopsy',
          'Medications',
          "Continuous Renal Replacement Therapy",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Nephrologists at MagnAid Hospital',
        paragraph: ['No matter if the condition is minor or complex, our expert nephrologists at MagnAid hospital ensure the accurate diagnosis of the issues for effective treatment.', 'Our nephrologists treat the following conditions at MagnAid Hospital-'],
        points: [
          "Kidney stones",
          "Chronic kidney disease",
          "Kidney infections",
          "Kidney failure",
          "Kidney cancer",
          "Kidney transplant and post-care",
          "Glomerulonephritis",
          "Urinary tract infection",
          "Polycystic Kidney Disease"
        ],
        images: [nephro_img_2, nephro_img_3]
      },
      galance: {
        title: 'Excellence in Nephrology',
        content: [
          "Nephrology is a field that focuses on the diagnosis and treatment of kidney-related issues.",
          "Nephrologists are specialists who effectively treat various kidney conditions using advanced technologies.",
          "Nephrologists at MagnAid Hospitals provide compassionate care and treat conditions ranging from kidney stones to kidney cancer.",
          "For precise diagnosis and effective treatment, they utilize the latest state-of-the-art machines."
        ],

      }, latestTecTitle: "Latest Technologies ",

      tools: [
        "Ultrasound",
        "CT Scanning",
        "Renal biopsy, ultrasound and doppler",
        "Advanced Diagnostic Tools",
        "Automated Peritoneal Dialysis",
        "Portable and advanced Dialysis Devices",
        "Scintigraphy",
        "Angiography"
      ],
      Faq: [
        {
          question: "What are the signs of kidney problems?",
          answer: "Fatigue, swelling in the legs or face, and changes in the urination pattern are some of the common symptoms of kidney problems."
        },
        {
          question: "How often should I visit a nephrologist if I have a kidney condition?",
          answer: "Depending on your condition and kidney health, your nephrologist will recommend follow-up visits."
        },
        {
          question: "Why choose MagnAid Hospital for nephrology care?",
          answer: "Nephrologists at MagnAid Hospital are skilled and provide compassionate care using the latest technologies. They offer personalized treatments based on patient needs, keeping patient health as the top priority."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Nephrologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Manoj Gupta',
            profession: 'Nephrologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Rina Patel',
            profession: 'Nephrologist'
          }
        ]
      }
    }
  ],

  surgical: [
    {
      title: 'General Surgery',
      aboutTitle: "What is General Surgery?",
      Icon: generalSurgery,
      description: 'Surgical treatment for abdominal, skin, and soft tissue conditions.',
      cardDes: 'Experience comprehensive surgical care from the experts offering personalized care for all conditions.',
      about: [
        'General surgery is a specialised branch of medical science which deals with treating different conditions within the body through surgical methods.',
        'The surgeons who perform the surgeries are incredibly skilled in treating a wide range of conditions and diseases by ensuring the patient’s safety and comfort before, during and after their surgery.',
        'General Surgeons of  MagnAid Hospital are highly dedicated to patients’ safety by prioritizing their wellness at every stage of the surgery by making use of advanced techniques and technologies.'
      ],
      metaTitle: "Best General Surgery Hospital  in Hyderabad |MagnAid Hospitals",
      metaDescription: "MagnAid Hospitals' General Surgery Department offers top surgery services with skilled surgeons. Trust us for the best hospital for surgery and expert care.",
      metaUrl: "general-surgery",
      image: gen_med_1,
      procedures: {
        title: "Why General Surgery is needed?",
        description: 'General surgery is a critical part of any healthcare unit as it provides effective treatment to patients who are struggling through any kind of medical conditions.General Surgeons of MagnAid Hospital perform surgery for the following reasons-',
        imageURL: gen_med_2,
        points: [
          'To get relief from chronic pain',
          'Removing the cancer-causing tumors',
          'When an organ does not function properly',
          'Treating the injuries caused by a major accident',
          'Terminate the infections for which the medications are ineffective.',
          'To address emergency conditions like appendicitis, internal bleeding',
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of Surgeries MagnAid Hospital Offers',
        points: [
          "Appendectomy",
          "Cholecystectomy",
          "Endocrine Surgeries",
          "Vascular Surgeries",
          "Deep vein thrombosis",
          "Debridement",
          "Hernia treatment"
        ],
        images: [gen_med_3, GeneralMedicine3]
      },
      galance: {
        title: 'Excellence in General Surgery',
        content: [
          "General surgery deals with the treatment of a wide range of medical conditions through surgical methods.",
          "General surgeons at MagnAid Hospital are highly skilled in performing surgeries using advanced technologies.",
          "General surgeons at MagnAid Hospital ensure the patient’s safety by addressing emergency conditions like appendicitis.",
          "They can treat a wide range of conditions, from simple to complex conditions, by providing personalised treatment plans."
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Along with rest, move around a little.",
          "Make sure to keep your surgical site clean and dry.",
          "Maintain a positive mindset and take a follow-up appointment.",
          "Stay hydrated, have a balanced diet and take medicines on time.",
          "Watch out for infections and report any discomfort to your surgeon.",
        ]
      },
      Faq: [
        {
          question: 'How do I know if I need surgery?',
          answer: 'When medications do not work, then based on your condition, your doctor will recommend you to a suitable surgeon who will further guide you on the next procedures.'
        },
        {
          question: ' How soon can I return to work or daily activities after undergoing surgery?',
          answer: 'It completely depends on the surgery you have undergone. Your surgeon will inform you beforehand about the recovery time.'
        },
        {
          question: 'Is general surgery safe for older adults?',
          answer: ' At MagnAid hospital, our surgeons use modern technologies and carry out the procedure with utmost care, ensuring the comfort of patients of all ages.'
        },
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled General Surgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: amrish,
            doctorName: 'Dr. Sidda Amrish Ram Reddy',
            profession: 'General Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Prasanna Grapati ',
            profession: 'General Surgeon'
          }
        ]
      }
    },
    {
      title: 'Obstetrics & Gynecology',
      Icon: gynecology,
      description: 'Comprehensive care for pregnancy, childbirth, and female reproductive health.',
      cardDes: 'Specialized obstetric and gynaecological services for women ensuring their health and comfort with compassionate care.',
      about: [
        "Obstetrics and gynaecology is a specialised branch in the medical field which takes care of the overall health of women by addressing the reproductive and gynaecological disorders.",
        'Obstetrics is a department whose major focus is to deal with pregnant women by effectively handling the labor and delivery of the baby through continuously examining the health of the mother and baby, by providing postpartum care.',
        'Gynecology is a department that deals with the diagnosis and treatment of the overall reproductive health of women and addresses the reproductive issues and disorders.',
        "OB/GYN of MagnAid Hospital are dedicated to provide the best care for women at every stage of their lives."
      ],
      aboutTitle: "What is Obstetrics & Gynecology?",
      metaTitle: "Best Hospital for Women's Health and Gynecology in Hyderabad",
      metaDescription: "MagnAid Hospitals is the best hospital for women's health, offering expert care in delivery, gynecology, and female check-ups. Schedule your appointment today.",
      metaUrl: "best-gynecologist-in-hyderabad",
      image: gyno_img_1,
      procedures: {
        title: "Why is Obstetrics and Gynecology needed?",
        description: 'Obstetrics and Gynecology is all about caring for women’s health in all her stages, be it the period of menarche, pregnancy, motherhood or menopause. They are the specialists to ensure the reproductive health of a women.The following are reasons why Obstetrics and Gynecology are needed-',
        imageURL: gyno_img_2,
        points: [
          "To ensure a healthy pregnancy",
          "To manage the hormonal imbalances",
          "To address the menstrual disorders",
          "To deal with the fertility-related issues",
          "Performs diagnosis and screening to detect early signs of diseases or infections",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of surgeries OB/GYN offers at MagnAid Hospital',
        points: ["Normal Vaginal Delivery",
          "C-Section (Cesarean) Delivery",
          "Hysterectomy",
          "Laparoscopy",
          "Hysteroscopy",
          "Myomectomy",
          "Dilation and Curettage (D&C) Procedure",
          "Ovarian Cystectomy",
          "Fertility Surgeries to Address Fertility Issues",
          "Cervical Biopsy", "Cosmetic Gynaecology",
          "Hysterosalpingography",
          "Vulvectomy",
          "Uterine (Artery) Fibroid Embolisation (UFE)",
        ],
        images: [gyno_img_4, gyno_img_3]
      },
      galance: {
        title: 'Excellence in Obstetrics and Gynecology',
        content: [
          "Gynecologists are experts in managing all the gynecological disorders among women.",
          "Obstetricians ensure the woman’s safety during her pregnancy and labor and take care of her post-delivery.",
          "OB/GYN at MagnAid Hospital are proficient in dealing with simpler to complex problems, be it menstrual disorder or fertility issues."
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Avoid heavy lifting and exercises until your surgeon permits.",
          "Never miss the follow-up appointments post-surgery for faster recovery.",
          "Prioritize personal hygiene, especially after surgeries related to the reproductive tract.",
          "Perform light pelvic and leg exercises to prevent discomforts at lower back and maintain blood circulation.",
          "Maintain spine alignment by sleeping on your back and placing a pillow under your knees, after a C-section or hysterectomy.",
        ]
      },
      Faq: [
        {
          question: "What is the difference between a gynecologist and an obstetrician?",
          answer: "Gynecologists specialize in addressing the overall reproductive health of a woman, while an obstetrician's role is to ensure a healthy pregnancy and childbirth. OB-GYNs are trained in both."
        },
        {
          question: "How soon can I return to my daily activities?",
          answer: "Your recovery time differs based on the type of surgical procedure you are undergoing. Minor surgery will require a few days, while major surgeries may take a few weeks to return to normal activities."
        },
        {
          question: "Will my menstrual cycle change after surgery?",
          answer: "It depends on the surgery. Surgery like hysterectomy will completely stop your menstrual cycles, while some surgeries will regulate the proper cycle."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled OB/GYNs at MagnAid Hospital',
        Doctors: [
          {
            photo: sindhu,
            doctorName: 'Dr Sindhu Kodali',
            profession: 'OB/GYN'
          },
          {
            photo: drsvg,
            doctorName: 'Dr K.B.Lakshmi',
            profession: 'OB/GYN'
          }
        ]
      }
    },
    {
      title: 'Orthopedics',
      Icon: OrthopedicIcon,
      description: 'Treatment of bone, joint, and musculoskeletal disorders.',
      cardDes: 'Personalized orthopaedic solutions for all of your joints, bones and muscle pains ensuring pain-free and seamless movements.',
      about: [
        'Orthopedics is also known as Orthopedic surgery, is a surgical branch in medicine which deals with treating conditions related to bones and muscles, either through surgery or non-surgical methods.',
        'Orthopedic surgeons deal with the treatment of various kinds of conditions among youngsters and in adults who have joint pain, sports injuries and take care of the skeletal system of the body.',
        'Orthopedic surgeons of MagnAid Hospital are highly skilled and experienced and address the issue with intensive care by utilising high-end technologies.'
      ], aboutTitle: "What is Orthopedics?",
      image: ortho_img_1,
      metaTitle: "Best Knee Replacement and Orthopedic Surgery in Hyderabad",
      metaDescription: "MagnAid Hospitals is the best hospital for knee replacement and orthopedic surgery. Our orthopedic specialists provide expert joint care. Consult our experts now",
      metaUrl: "hyderabad-orthopedic-hospital",
      procedures: {
        title: "Why is orthopedic surgery needed?",
        description: 'Orthopedic surgery is required to treat the various conditions that help in treating the issues related to bones, joints, ligaments, and muscles. They help the patients to bring back the proper functioning of these parts, thus improving the quality of life.The following are the reasons why orthopedic surgery is needed-',
        imageURL: ortho_img_2,
        points: [
          "To treat fractures", "To treat sports injury ",
          "Treat joint pain",
          "To improve mobility",
          "Treat spinal issues and back pain",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of Surgeries Orthopedic Services at MagnAid Hospital',

        points: [
          "Arthroscopy & sports Injuries",
          "Hip, Knee, and Shoulder Replacement",
          "Trauma",
          "Osteotomy",
          "Laminectomy",
          "Endoscopic Spine Procedures",
          "Tendon Repair Surgery",
          "Spine Procedure - Discectomy, Laminectomy, Fusion"
        ],
        images: [ortho_img_3, ortho_img_1]
      },
      galance: {
        title: 'Excellence in Orthopedics',
        content: [
          "With proper care and a balanced diet, a patient can ensure a healthy recovery.",
          "Orthopedic surgeons perform surgeries to treat bone, joint, and muscle-related problems.",
          "They help in improving mobility among the patients effectively, with a quick recovery time.",
          "MagnAid Hospital offers a range of surgeries which are carried out by top professionals using advanced technologies.",
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Increase the intensity gradually.",
          "Prevent body stiffness through light exercises.",
          "Manage your weight to reduce the unnecessary weight on your joints.",
          "Explore alternative medicines to reduce pain, like hot or cold massage.",
          "Increase the intake of calcium, vitamin D, and proteins to strengthen your bones and for faster recovery.",
        ]
      },
      Faq: [
        {
          question: "How do I know if I need joint replacement surgery?",
          answer: "When you feel difficulty performing daily activities and there is still persistent pain in the joints even after taking medications and therapy, then a joint replacement surgery will be recommended."
        },
        {
          question: "Are there minimally invasive options available?",
          answer: "For faster recovery and less pain, our orthopedic surgeons perform surgeries like arthroscopy with small incisions."
        },
        {
          question: "How will I know whether the surgery is the best option for me?",
          answer: "Your orthopedicians will provide the option about the surgeries when other treatments are not effective."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Orthopedic Surgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: vamsi,
            doctorName: 'Dr Vamshikrishna Terala',
            profession: 'Orthopedic Surgeon'
          },
        ]
      }
    },
    {
      title: 'Urology', aboutTitle: "What is Urology?",
      Icon: urology,
      description: 'Comprehensive care for urinary tract and male reproductive system issues.',
      cardDes: 'For all of the urinary and male reproductive health, offering advanced treatments with focused diagnosis and personalised treatments.',
      about: [
        'Urology is a specialised medical branch whose major focus is on examining and treating diseases or infections in the urinary tract of males and females. It also focuses on the treatment of the male reproductive system.',
        'Urologists are also specialist surgeons who are concerned with the treatment and management of various conditions related to urinary infections, kidney stones or male reproductive disorders using surgical and non-surgical procedures.',
        'Urologists at MagnAid Hospital are highly qualified and skilled in treating vast conditions related to the urinary tract with an effective treatment approach.',],
      image: urology_img_1,
      metaTitle: "Best Hospital for Urology in Hyderabad | Magnaid Hospital",
      metaDescription: "MagnAid Hospitals is the best hospital for kidney stones. Our urology department offers expert treatment with top urology surgeons for kidney stones and care.",
      metaUrl: "best-urologist-in-hyderabad",
      procedures: {
        title: "Why are urologists needed?",
        description: 'Urologists play a significant role in ensuring urinary health and managing male reproductive health by addressing the problems through proper diagnosis and giving treatment plans.Urologists at MagnAid Hospital manage various issues like-',
        imageURL: urology_img_2,
        points: [
          "Pelvic pain",
          "Cures bladder cancer",
          "Manages kidney stones",
          "Genital abnormalities",
          "Treats urological cancer",
          "Treats bladder infections",
          "Treats urinary tract infections",
          "Discomfort and difficulty while urinating",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of Surgeries Urologists at MagnAid Hospital perform',

        points: [
          "Ureteroscopy",
          "Cystectomy",
          "Nephrectomy",
          "Suspension Surgery",
          "Prostatectomy",
          "Penile Implants",
          "Urinary Diversion",
          "Genital Reconstruction"
        ],
        images: [urology_img_3, urology_img_4]
      },

      galance: {
        title: 'Excellence in Urology',
        content: [
          "They use advanced procedures and technologies to ensure precise treatment with faster recovery.",
          "With proper hygiene care and regular checkups, one can avoid these diseases and their recurrences.",
          "Urology is the medical branch that deals with the diagnosis and treatment of infections or diseases in the urinary tract.",
          "Urologists of MagnAid Hospital are experts who ensure overall urinary health by addressing genital abnormalities and urological cancers.",
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Wear loose and comfortable clothing to keep the surgical site free.",
          "Seek medical attention when you see unusual signs and have a routine check-up.",
          "Follow proper hygiene, especially around the genital and surgical site, to prevent infections.",
          "Avoid excessive caffeine, spicy food, and acidic drinks to avoid irritation of the urinary tract.",
          "Follow the liquid intake as prescribed by your surgeon to prevent dehydration and control urination.",
        ]
      },
      Faq: [
        {
          question: "Do urologists only treat men?",
          answer: "Urologists at MagnAid Hospital treat both men and women."
        },
        {
          question: "Can a urologist help with fertility issues?",
          answer: "Yes, the urologists at MagnAid Hospital address male fertility issues by offering treatments like vasectomy reversal and sperm retrieval."
        },
        {
          question: "Can a urologist help with recurring urinary tract infections (UTIs)?",
          answer: "Yes, they specialize in the field and will closely diagnose the root cause of your frequent UTIs and provide a personalized treatment plan to prevent occurrences."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Urologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Karthik Maripeedi',
            profession: 'Urologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Dutta Prasad',
            profession: 'Urologist'
          }
        ]
      }
    },
    {
      title: 'ENT',
      Icon: ent,
      description: 'Surgical and non-surgical treatment of ENT disorders.',
      cardDes: 'Expert care and advanced treatment for your ear, nose, and throat-related concerns with precise diagnosis and guaranteed relief.',
      about: [
        'ENT stands for Ear, Nose and Throat.',
        'The ENT specialists are also called otolaryngologists, who are specialised in effectively treating any sort of infections or diseases related to the ear, nose, throat, head and neck.',
        'ENT Specialists at MagnAid Hospital are experts in providing personalised treatment plans by thorough diagnosis of the conditions, no matter if the condition is as simple as an ear infection or as complex as neck surgeries.'
      ],
      image: ent_img_1,
      metaTitle: " Best ENT Hospital and Otolaryngology Specialist in Hyderabad",
      metaDescription: "MagnAid Hospitals' ENT Department provides expert care with top otolaryngologists. Our otolaryngology hospital offers comprehensive treatment for ENT issues.",
      metaUrl: "ent-hospital-in-hyderabad",
      aboutTitle: "What is ENT?",
      procedures: {
        title: "Why do we need ENT Specialists?",
        description: 'The ear, nose and throat are the essential human organs. When any infections or diseases are caught in these organs, then their effective treatment is a must and should be performed by specialists.ENT specialists of MagnAid Hospital play a vital role as they help patients to get relive from various conditions, as they address conditions like-',
        imageURL: ent_img_2,
        points: [
          "Treats voice disorders",
          "Prevents nasal blockages",
          "Helps with sleep disorders",
          "Addresses breathing problems",
          "Treats sinus and Treats tonsils",
          "Treats certain throat conditions",
          "Treats hearing loss and ear infections",
          "Addresses congenital problems in the ear",
        ],
        bottomLine: null
      },
      conditionsTreat: {

        heading: 'Types of Surgeries ENT specialists perform',
        points: [
          "Cochlear Implant Surgery",
          "Ear Tube Placement",
          "Tympanoplasty",
          "Endoscopic Sinus Surgery",
          "Tonsillectomy",
          "Turbinate Reduction Surgery",
          "Laryngoscopy",
          "Adenotonsillectomy",
          "Therapeutic Endoscopy",
          "Phonosurgery",
          "Snoring Surgery",
          "Ear & Skull Base Surgery"
        ],
        images: [ent_img_3, ent_img_5]
      },
      galance: {
        title: 'Excellence in ENT',
        content: [
          "They address issues from hearing loss to tonsils and voice disorders.",
          "They provide solutions medically and through surgeries using advanced technologies.",
          "They carry out advanced procedures to restore the health and quality of life of patients with faster recovery.",
          "ENT specialists, also called otolaryngologists, are specialized in treating a wide range of conditions related to the ear, nose, and throat.",
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Avoid loud noises and pressure changes after ear surgeries.",
          "Avoid dust and strong odors to prevent irritation in the throat and nasal passages.",
          "Avoid eating spicy and acidic food after throat treatment and maintain a soft diet.",
          "Keep updated about your recovery with your doctor and report any discomforts immediately.",
          "Maintain proper head posture to avoid swelling, especially after sinus or nasal surgeries.",
        ]
      },

      Faq: [
        {
          question: 'Are ENT surgeries safe?',
          answer: 'At MagnAid Hospital, our ENT specialists utilise modern and advanced technologies for precise and safe surgery.'
        },
        {
          question: 'Will my singing voice change after a throat surgery?',
          answer: 'In most cases, patients have experienced an improvement in their singing voice.Although if the vocal cords are involved in the surgery, then there will be a slight difference in the voice.'
        },
        {
          question: 'Can kids have ENT surgeries too?',
          answer: 'If kids who are frequently affected by infections or have trouble breathing, then the ENT specialists may recommend surgery as a permanent solution to the persistent problem.'
        },
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled ENT Specialists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Ranjith Parupali',
            profession: 'ENT Specialist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. A.Linen',
            profession: 'ENT Specialist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Prawahar Chileveru',
            profession: 'ENT Specialist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Mrudula Mukiri',
            profession: 'ENT Specialist'
          },

        ]
      }
    },
    {
      title: 'Spine Surgery',
      Icon: spineSurgery,
      description: 'Surgical solutions for spinal injuries, herniated discs, and scoliosis.',
      cardDes: 'Advanced spine surgery to restore movement and alleviate pain through specialized surgical care.',
      about: [
        'Spine surgery is a surgical procedure to cure the various disorders related to the spine and the surrounding tissues. The goal of spine surgery is to relieve patients and improve the quality of life from pain when medications or physical therapy do not work.',
        'Spine surgeons closely examine the condition using modern technologies and, depending on the condition of the patients, they perform minimally invasive surgery for faster recovery.',
        "Spine surgeons at MagnAid Hospital have decades of experience and are proficient in performing successful surgeries to restore normal functioning and ensure overall spinal health."
      ],
      aboutTitle: "What is Nephrology?",
      image: spine_img_1,
      metaTitle: "Best Spine Surgery Hospitals and Spine Surgeons in Hyderabad",
      metaDescription: "Experience expert spinal care at MagnAid Hospitals, Hyderabad. Our top spine surgeons provide advanced spine surgery at the best spine hospital. Book today!",
      metaUrl: "spine-surgery-hospitals",
      procedures: {
        title: "Why do we need Spine Surgeons?",
        description: 'Spine surgeons are an essential part of the medical department as they ensure the well-being and brings back the comfort and mobility of the patients who are dealing with severe spine disorders.Spine Surgeons at MagnAid Hospital perform the surgeries with their expertise to treat the following conditions-',
        imageURL: spine_img_2,
        points: [
          "Treats tumor growth",
          "Corrects spinal deformity",
          "Chronic back and neck pain",
          "Cures fractures or sports injuries",
          "Treats inflammatory and neoplastic conditions of the spine",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of surgeries Spine Surgeons perform',
        points: [
          "Spinal Fusion",
          "Disc Replacement Surgery",
          "Discectomy",
          "Kyphoplasty and Vertebroplasty",
          "Laminectomy",
          "Cervical Spine Surgery",
          "Chiropractic",
          "Scoliosis Correction Surgery",
        ],
        images: [spine_img_3, spine_img_4]
      },
      galance: {
        title: 'Excellence in Spine Surgery',
        content: [
          "Spine surgery brings relief from chronic back pain, fractures, and helps maintain spinal health.",
          "With proper diet, preventive methods, and follow-up checkups, you will be able to retain a healthy lifestyle.",
          "They are experienced in treating a wide range of conditions, from sports injuries to neoplastic spine conditions.",
          "Spine surgeons at MagnAid Hospital are experts in using advanced technologies to treat spinal issues for faster recovery.",
        ],
      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Maintain good spine posture by using ergonomic chairs.",
          "Avoid heavy lifting and sudden movements to prevent jerks.",
          "Address any unusual discomforts to your surgeon immediately.",
          "Ensure a diet rich in calcium and vitamin D to strengthen bones.",
          "Practice gentle walking and light exercises to prevent stiffness.",
        ]
      },
      Faq: [
        {
          question: "How long does spine surgery take?",
          answer: "Most of the surgeries will take around 1-4 hours. But some complex surgeries will take even longer."
        },
        {
          question: "Can my back problem return even after surgery?",
          answer: "Sometimes the spinal issues may recur but it is rare. Spine surgeons of MagnAid hospital provide preventive tips to reduce the risk."
        },
        {
          question: "Is spine surgery a permanent fix?",
          answer: "For long-term success after the spinal surgery, one must maintain a healthy lifestyle to obtain significant results."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Surgical Oncologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Amrish',
            profession: 'Surgical Oncologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Vishal',
            profession: 'Surgical Oncologist'
          }
        ]
      }
    },
    {
      title: 'Surgical Gastroenterology',
      Icon: gastroenterology,
      description: 'Surgical treatment for gastrointestinal tract disorders.',
      cardDes: 'Get relief from gastrointestinal issues with specialized surgical care with precise treatment for any digestive conditions.',
      about: [
        'Surgical Gastroenterology is a specialised surgical branch in medicine which deals with the diagnosis and treatment of conditions related to the digestive tract through minimally invasive surgeries.',
        'Surgical gastroenterologists are the specialists who treat any kind of problems related to the digestive system when medications do not show any effect.',
        'At MagnAid Hospital, the gastroenterology surgeons are highly trained to carry out any complicated procedures using advanced technologies to improve the health of patients.'
      ],
      aboutTitle: "What is Surgical Gastroenterologyy?",
      image: gastro_img_1,
      metaTitle: "Best Gastro Surgery and Liver Surgery Hospitals in Hyderabad",
      metaDescription: "Experience expert gastroenterology surgery at MagnAid Hospitals. We offer liver surgery, appendicitis surgery, and appendectomy with precision and top-notch care",
      metaUrl: "gastrology-surgery",
      procedures: {
        title: "Treatments and Procedures",
        description: 'When you are dealing with any sort of digestive issues which does not persist even after following the medications, then surgical gastroenterologists perform the surgeries to cure the problems effectively.We need Surgical gastroenterologists for the following reasons-',
        imageURL: gastro_img_2,
        points: [
          "Treats appendicitis",
          "Cures stomach ulcers",
          "Treats internal bleeding",
          "Addresses obesity issues",
          "Treats gastrointestinal cancers",
          "Treats gallbladder, hernia, and pancreas-related problems"
        ],
        bottomLine: null
      },
      conditionsTreat: {
        title: 'Types of surgeries our Surgical Gastroenterologists perform',
        heading: 'Conditions Treated by Surgical Gastroenterologists at MagnAid Hospital',
        points: [
          "Gastrectomy",
          "Gastric Balloon",
          "Laparoscopic Appendicectomy",
          "Bariatric Surgery",
          "Laparoscopic Gallbladder Surgery",
          "Laparoscopic Adrenalectomy",
          "Laparoscopic Spleen Removal",
          "Anti-Reflux Surgery",
          "Cholecystectomy",
          "Bowel Obstruction Surgery"
        ],
        images: [gastro_img_3, gen_med_1]
      },
      galance: {
        title: 'Excellence in Surgical Gastroenterology',
        content: [
          "With proper care after surgery, one can recover faster.",
          "Surgical gastroenterology deals with treating a wide range of conditions related to the digestive system.",
          "A surgical gastroenterologist treats digestive system conditions using advanced technologies, ensuring patient comfort and safety.",
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Take enough rest.",
          "Stay hydrated to prevent dehydration.",
          "Eat small, frequent meals instead of large portions at once.",
          "Watch for unusual signs and report them to your surgeon immediately.",
          "Follow a simple, bland diet initially to avoid disturbing the digestive system.",
        ]
      },
      Faq: [
        {
          question: "Can I live without any part of my stomach?",
          answer: "After the surgery, your digestive system will adjust accordingly."
        },
        {
          question: "Are surgical procedures for digestive diseases safe?",
          answer: "Surgeries performed by the experienced surgical gastroenterologists who use advanced technologies will ensure the patient’s safety with a higher success rate."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Surgical Gastroenterologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Ravi Kumar',
            profession: 'Surgical Gastroenterologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Anita Sharma',
            profession: 'Surgical Gastroenterologist'
          }
        ]
      }
    },
    {
      title: 'Surgical Oncology',
      Icon: medicalOncology,
      description: 'Cancer surgery for tumors and malignancies.',
      cardDes: 'Personalized treatments for cancer along with dedicated experts for advanced surgical oncology care through surgeries.',
      about: [
        'Surgical oncology is a specialised surgical branch in medicine which deals with the diagnosis and effective treatment for the removal of cancer cells, tissues or cysts through surgical methods.',
        'Surgical oncologists are professionals who are highly trained in dealing with the wide range of cancers at any stage. To further improve the success rate, they often collaborate with the oncologists from another department.',
        "Oncologists at MagnAid Hospital are highly qualified to provide effective cancer treatment plans based on the requirements of each patient's needs and conditions by utilising the high-end advanced technologies."
      ],
      image: ocno_img_1,
      metaTitle: "Best Oncology Surgeons and Cancer Hospitals in Hyderabad",
      metaDescription: "MagnAid Hospitals offers expert surgical oncology care with top oncology surgeons in Hyderabad. We specialize in oncology plastic surgery and pediatric surgery.",
      metaUrl: "cancer-hospital-in-hyderabad", aboutTitle: "What is Surgical Oncology?",
      procedures: {
        title: "Why are surgical oncologists needed?",
        description: 'Surgical oncologists are specialists who precisely diagnose the presence of cancer and treat it effectively with advanced technologies, keeping the patient’s safety and comfort as the first priority.Surgical oncologists at MagnAid Hospital perform surgeries for the following reasons-',
        imageURL: ocno_img_2,
        points: [
          'Removes cancer-causing tumors',
          'Treats cancer of various organs at any stage',

        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of Surgeries Our surgical oncologists perform',
        points: [
          "Cystectomy",
          "Segmentectomy",
          "Curative Surgery",
          "Lymph Node Biopsy",
          "Total Gastrectomy",
          "Prophylactic Surgery",
          "Renal Cell Carcinoma",
          "Robotic Nephrectomy Surgery",
          "Video-Assisted Thoracoscopic Surgery",
        ],
        images: [ocno_img_3, ocno_img_4]
      },
      galance: {
        title: 'Excellence in Surgical Oncology',
        content: [
          "Specialists at MagnAid Hospital precisely target cancerous cells and treat them with advanced technology.",
          "Oncology deals with the diagnosis and treatment of cancers, tumors, and cancer-causing cells through surgical methods.",
          "They are experienced in treating various kinds of cancers and often collaborate with specialists from different departments to provide effective treatment."
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Avoid alcohol consumption.",
          "Never skip the prescribed medications.",
          "Restore your gut health by eating fermented food.",
          "Include nutrient and antioxidant-rich food in your diet.",
          "Have regular visits with your oncologist to screen for the recurrence of the issue.",
        ]
      },
      Faq: [
        {
          question: "Will surgery cure my cancer?",
          answer: "When the cancer is detected at the early stages, there is a high success rate of curing cancer through surgery."
        },
        {
          question: "How do I know if my surgery was successful?",
          answer: "After your surgery, your surgeon will conduct the follow-up check-up routines to monitor the effectiveness of the surgery. It is then that you will get to know about the success rate of your surgery."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Surgical Oncologists at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Srikanth Jakkula',
            profession: 'Surgical Oncologist'
          },
          {
            photo: drsvg,
            doctorName: 'Dr Nived Rao Balmoori',
            profession: 'Surgical Oncologist'
          }
        ]
      }
    },
    {
      title: 'Neurosurgery',
      Icon: neurology,
      description: 'Surgical care for brain, spine, and nervous system conditions.',
      cardDes: 'Treatment for neurological conditions and improve the quality of life through advanced surgeries with comprehensive neurosurgery.',
      about: [
        'Neurosurgery is the specialised branch of medical science which deals with the diagnosis and treatment of conditions related to the brain, spinal cord and the nervous system through surgical procedures.',
        'Neurosurgeons are professionals who are skilled in performing surgeries to treat any neurological disorders from the brain to the spinal cord and offer life-saving treatment plans to patients.',
        "Neurosurgeons at MagnAid Hospital are dedicated towards providing treatment solutions using advanced technologies."
      ], aboutTitle: "What is Neurosurgery?",
      image: neuro_img_1,
      metaTitle: " Best Neurosurgery and Neurology Hospitals in Hyderabad",
      metaDescription: "Get expert care at MagnAid Hospitals, Hyderabad, one of the top neurosurgery hospitals. Consult the best neurosurgeon at the best neurology hospital today!",
      metaUrl: "neurosurgery",
      procedures: {
        title: "Why do we need Neurosurgeons?",
        description: 'Neurosurgeons play an important role in treating the complicated conditions related to the nervous system and help in improving the patient’s quality of life.We need neurosurgeons as they hold the expertise in treating various conditions like-',
        imageURL: neuro_img_2,
        points: [
          "Epilepsy",
          "Treats brain tumors",
          "Treats brain cancer",
          "Treats head injuries",
          "Cerebrovascular disease",
          "Manages spinal cord diseases/injuries",
          "Movement disorders (Parkinson’s disease)",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of Surgeries Neurosurgeons Perform',
        points: [
          "Craniotomy",
          "Deep Brain Stimulation",
          "Epilepsy Surgery",
          "Brain Tumor Surgery",
          "Spinal Fusion",
          "Brachial Plexus Surgery",
          "Laser Interstitial Thermal Therapy",
          "Endoscopic Surgery"
        ],
        images: [neuro_img_3, neuro_img_4]
      },
      galance: {
        title: 'Excellence in Neurosurgery',
        content: [
          "With proper diet, regular exercise, and routine check-ups, patients heal quickly.",
          "They are proficient in performing advanced surgeries using modern technologies, ensuring faster recovery.",
          "Our neurosurgeons at MagnAid Hospital are highly skilled and experienced in treating various disorders related to the nervous system with effective treatment.",
          "Neurosurgery is a specialized medical branch that focuses on diagnosing and treating conditions related to the nervous system, brain, and spinal cord surgically.",
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Keep yourself hydrated and drink electrolyte drinks.",
          "Try doing light head and neck exercises under supervision.",
          "Avoid any activities that tend to put pressure on your neck, head, and spine regions.",
          "Include anti-oxidant, omega-3 fatty acids, Vitamin B, C, and D rich food in your diet to promote brain function.",
        ]
      },
      Faq: [
        {
          question: "What are the risks of neurosurgery?",
          answer: "Our Neurosurgeons at MagnAid Hospital use advanced technologies which will increase the recovery time and success rate with low risks."
        },
        {
          question: "Can I live a normal life after brain surgery?",
          answer: "Yes, you can lead a normal life after our brain surgery, as many patients return to their normal activities soon after their recovery."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Neurosurgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Keerthi Sidda',
            profession: 'Neurosurgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr.J.Akshitha Reddy',
            profession: 'Neurosurgeon'
          }
        ]
      }
    },
    {
      title: 'Plastic Surgery',
      Icon: DermotologyIcon,
      description: 'Reconstructive and cosmetic surgical procedures.',
      cardDes: 'Enhance your beauty with advanced plastic and cosmetic surgery with solutions tailored to personalized care.',
      about: [
        'Plastic and Cosmetic surgeries are specialised surgical procedures which involve the reconstruction and enhancement of the facial and overall body features.',
        'Plastic surgeons focus on repairing the defects that are either present from birth or occur due to any accident to retain the original look.Cosmetic surgeons perform the surgery to enhance the appearance of the person.'
        , "The goal of the plastic and cosmetic surgeons at MagnAid hospital is to enhance the personality and instil confidence among the patients."
      ],

      aboutTitle: "What is Plastic Surgery?",
      image: plastic_img_1,
      metaTitle: " Best Plastic Surgery and Cosmetic Surgeons in Hyderabad",
      metaDescription: "MagnAid Hospitals,the best plastic surgery hospital in Hyderabad, offers expert care from top surgeons. Get the best cosmetic surgery. Book a consultation today!",
      metaUrl: "plastic-surgery",
      procedures: {
        title: "Why do we need Cosmetic and Plastic Surgery?",
        description: 'It not only deals with the appearance, but it is essential to restore and enhance the natural beauty to make you feel more comfortable by correcting certain features that have been damaged.Cosmetic and Plastic surgeons deal with the following conditions-',
        imageURL: plastic_img_2,
        points: [
          "Contours body in ideal shape",
          "Helps in reducing aging signs",
          "Corrects the defects from birth time",
          "Helps improve the physical appearance",
          "Restores the appearance after an accident",
        ],
        bottomLine: null
      },
      galance: {
        title: 'Excellence in Plastic and Cosmetic Surgery',
        content: [
          "Cosmetic surgery is performed to enhance physical appearance, helping to boost confidence.",
          "At MagnAid Hospital, our surgeons ensure the safety of our patients by utilizing modern technologies.",
          "For long-lasting results without any side effects, proper care must be taken as prescribed by the doctor post-surgery.",
          "Plastic surgery is essential to repair defects that are present from birth or to correct damage caused to the skin via accident.",
        ],

      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Report your surgeon immediately if infections occur.",
          "Perform exercises like deep breathing to improve oxygen flow.",
          "Avoid coming under direct exposure to sunlight after cosmetic and plastic surgery.",
          "Include citrus fruits, eggs, and broth to boost collagen and repair skin from within.",
          "Avoid using skin care products or makeup around the treated site until your surgeon permits.",
        ]
      },
      conditionsTreat: {
        heading: 'Conditions Treated by Plastic Surgeons at MagnAid Hospital',
        points: [
          "Rhinoplasty",
          "Facelift and Neck Lift",
          "Liposuction",
          "Breast Augmentation or Reduction",
          "Botox and Fillers",
          "Laser Treatments",
          "Brow Lift",
          "Eyelid Surgery",
          "Abdominoplasty",
          "Gynaecomastia",
          "Blepharoplasty",
          "Hand Surgery"
        ],
        images: [dermi_img_3, dermi_img_4]
      },
      Faq: [
        {
          question: "Will my surgery results look natural?",
          answer: "Surgeons at MagnAid Hospital use advanced technologies to achieve natural results which is very close to your expectations."
        },
        {
          question: "Can I see how I will look after surgery before the procedure?",
          answer: "Our surgeons will produce a digital view of the result in advance by using advanced imaging technologies to show you the outcome."
        }
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Plastic Surgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr Arjun Reddy Marathi',
            profession: 'Plastic Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr K.B. Lakshmi',
            profession: 'Plastic Surgeon'
          }
        ]
      }
    },
    {
      title: 'Vascular Surgery',
      Icon: vascular,
      description: 'Surgical treatment for blood vessel diseases.',
      cardDes: 'With expert vascular surgery care through advanced treatments for conditions affecting blood vessels and circulation.',
      about: [
        'Vascular surgery is a specialised branch of the medical field which deals with the diagnosis of problems related to the blood vessels, like arterial diseases, aneurysms and venous disorders and treating them.',
        'Vascular surgeons are specialists in effectively treating all the conditions and diseases related to the vascular system. They prevent life-threatening situations from getting complicated by treating these conditions on time through surgical methods.'
        , "Vascular surgeons at MagnAid Hospital are dedicated towards patients’ safety by keeping their comfort as top priority and ensuring to bring back their quality of life."],
      image: vascular_img_1,
      metaTitle: "Best Vascular Surgeons and Surgery Services in Hyderabad",
      metaDescription: "Experience expert vascular surgery at MagnAid Hospitals, Hyderabad. We offer vascular surgery services, focusing on blood vessels and treatments. Book now.",
      aboutTitle: "What is Vascular Surgery?",
      metaUrl: "vascular-surgery",
      procedures: {
        title: "Why is it necessary?",
        description: 'Vascular surgery is an essential unit for any healthcare center, as it deals with the treatment of blood vessels by improving the blood flow to improve the patient’s condition.Vascular surgeons at  MagnAid Hospital perform the surgery for the following reasons-',
        imageURL: vascular_img_2,
        points: [
          "Aneurysms",
          "Varicose veins",
          "Remove blockages",
          "Lymphatic disorders",
          "Treat arterial diseases",
          "Deep Vein Thrombosis (DVT)",
          "Treat damaged blood vessels",
          "Vascular injuries and infections",
        ],
        bottomLine: null
      },
      galance:
      {
        title: 'Excellence in Vascular Surgery',
        content: [
          "Vascular surgery is a medical field that focuses on the treatment of disorders related to the vascular system, like the blood vessels.",
          "Vascular surgeons play an important role in addressing and curing a variety of conditions with advanced technologies.",
          "Vascular surgeons at MagnAid Hospital are skilled at keeping life-threatening conditions at bay and improving the patient’s quality of life."
        ]
      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Keep yourself hydrated enough to promote blood flow.",
          "Take enough rest and maintain healthy sleep to recover faster.",
          "Wear loose and comfortable clothing for proper blood circulation.",
          "Stay away from heat exposures to prevent dilation of blood vessels.",
          "Include Vitamin K and omega-3 fatty acid-rich food to strengthen your vascular health.",
        ]
      },
      conditionsTreat: {
        heading: 'Types of Surgeries MagnAid Hospital offers',
        points: [
          "Angioplasty",
          "Carotid Endarterectomy",
          "Endovascular Stent Graft",
          "Peripheral Artery Bypass Surgery",
          "Endovascular Aneurysm Repair (EVAR)",
        ],
        images: [vascular_img_3, vascular_img_4]
      },

      Faq: [
        {
          question: 'What if I treat my vascular problem when needed?',
          answer: 'When you delay your treatment for the vascular disorders, then the condition may worsen and lead to stroke, blood clots or limb loss.'
        },
        {
          question: 'Can vascular issues come back after surgery?',
          answer: 'Vascular surgery, when performed at MagnAid Hospital then our surgeons will cure the issue permanently through surgeries. And following a healthy lifestyle routine will prevent the issue.'
        },

      ],

      availableDoctors: {
        title: 'Meet our Professional and Skilled Vascular Surgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Gnaneshwar Atturu',
            profession: 'Vascular Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Puneeth Joopali',
            profession: 'Vascular Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Basvaraj',
            profession: 'Vascular Surgeon'
          },
        ]
      }
    },
    {
      title: 'Pediatric Surgery',
      Icon: pedeiatrics,
      description: 'Specialized surgical care for infants and children.',
      cardDes: 'Focused on the unique needs of your growing children with comprehensive pediatric surgical care for their optimal health.',
      about: [
        'Pediatric Surgery is a specialised branch in the medical field which deals with the diagnosis and treatment of various conditions among infants, children and adolescents, typically below the age of 18 years.',
        'Pediatric surgeons are experienced professionals performing surgeries on children to ensure their healthy development through effective treatment methods.',
        'Pediatric surgeons at Manaid Hospital are dedicated towards providing effective treatment according to the needs of each child.'
      ], aboutTitle: "What is Pediatric Surgery?",
      image: pedia_img_1,
      metaTitle: "Best Pediatric Hospitals and Heart Surgeon in Hyderabad",
      metaDescription: "Discover the best pediatric surgery services at MagnAid Hospitals, Hyderabad. Our expert pediatric surgeons offer heart, general, and orthopedic surgery and etc",
      metaUrl: "best-pediatric-surgeon-in-hyderabad",
      procedures: {
        title: "Why are Pediatric surgeons needed?",
        description: 'Pediatric surgeons play a vital role in the well-being of infants and children, as they effectively diagnose the various conditions that affect the healthy growth of children.Pediatric Surgeons of the MagnAid Hospital perform surgeries for various reasons like-',
        imageURL: treatmentFollowed,
        points: [
          "Tumor treatments",
          "Urological conditions",
          "Neonatal surgical care",
          "Gastrointestinal disorders",
          "Corrects abnormalities present from birth",
          "Emergency surgeries to prevent long term disability",
        ],
        bottomLine: null
      },
      galance: {
        title: "Excellence in Pediatric Surgery",
        content: [
          "They perform various surgeries, including emergency surgeries, to prevent any disability in the future.",
          "Pediatric surgeons at MagnAid Hospital are professionals who ensure the healthy development of children through surgical procedures.",
          "Pediatric surgery is a specialized medical field that deals with treating various medical conditions in infants and children under 18 years of age.",
        ]
      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Keep the surgical site clean and dry.",
          "Ensure your kid has plenty of fluids and nutrient-rich foods.",
          "Make your kids have enough rest to avoid reopening of the wound.",
          "Have a scheduled follow-up visit with your surgeon to discuss any concerns.",
          "Make sure your kid washes their hands before touching the site to prevent infections.",
        ]
      },
      conditionsTreat: {
        heading: 'Types of Pediatric Surgeries at MagnAid Hospital',
        points: [
          "Appendectomy",
          "Bowel Obstruction Surgery",
          "Wilms’ Tumor Removal",
          "Bone Repair Surgery",
          "Thoracic surgery",
          "Oncology surgery",
          "Congenital Lung Malformation Surgery",
        ],
        images: [pedia_img_2, pedia_img_3]
      },
      Faq: [
        {
          question: 'Is pediatric surgery safe for children?',
          answer: 'Pediatric surgery when performed by the experienced surgeons then it is completly safe as they keep child’s health aas first priority.'
        },
        {
          question: 'What happens if my child needs surgery urgently?',
          answer: 'For emergency cases, Pediatric surgeons at magnaoid Hospital perform emergency surgeries to normalise the child’s condition.'
        },
      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled Pediatric Surgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Gunjan Shoor',
            profession: 'Pediatric Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Babu Rao',
            profession: 'Pediatric Surgeon'
          }
        ]
      }
    },
    {
      title: 'OMFS',
      Icon: omfs,
      description: 'Surgical care for facial trauma, jaw disorders, and dental implants.',
      cardDes: 'Get advanced care treatment for facial injuries, dental issues, and complex jaw conditions with precision and care.',
      about: [
        'OMFS stands for Oral and Maxillofacial Surgery.',
        'OMFS deals with the treatment of diseases, injuries or infections around the mouth, jaws, face or neck.',
        'OMF surgeons are skilled and trained in treating medical and dental conditions, which makes them proficient in performing facial surgeries.'
      ],
      aboutTitle: "What is OMFS?",
      image: omfs_img_1,
      metaTitle: "Best OMFS Department in Hyderabad - MagnAid Hospitals",
      metaDescription: "Experience the best Oral and Maxillofacial Surgery (OMFS) at MagnAid Hospitals, Hyderabad. Our OMFS surgeons specialize in facial reconstruction and teeth removal.",
      metaUrl: "omfs-surgeon",
      procedures: {
        title: "Why do we need OMF surgeons?",
        description: 'OMFS helps in diagnosing and treating the complex conditions of mouth, jaws , face and neck to improve the overall look and functioning of the oral and facial conditions.We need OMFS in following cases-',
        imageURL: omfs_img_2,
        points: [
          "Dental implants",
          "Treating oral cancer",
          "Repairing facial bones",
          "Improving jaw functions",
          "Removal of wisdom teeth",
        ],
        bottomLine: null
      },
      conditionsTreat: {
        heading: 'Types of surgeries performed at MagnAid Hospital',
        points: [
          "Jaw surgery",
          "Bone grafting",
          "Oral cancer surgery",
          "Facial trauma surgery",
          "Distraction Osteogenesis",
          "Maxillofacial Prosthetics",
          "Temporomandibular Joint surgery",
        ],
        images: [omfs_img_3, omfs_img_4]
      },
      galance: {
        title: "Excellence in OMFS",
        content: [
          "OMFS is a specialized branch to treat diseases, injuries, or infections in the mouth, neck, jaws, and face.",
          "OMF surgeons are professionals who perform surgical treatments to correct and restore the natural look and functioning.",
          "OMF surgeons at MagnAid Hospital use advanced technologies for effective treatment with precise diagnosis for enhanced facial functioning."
        ]
      },
      tips: {
        title: "Heal the Right Way with These Post-Surgery Tips!",
        points: [
          "Keep yourself hydrated and follow a simple diet.",
          "Use soft bristles for brushing to avoid injuries at the surgical site.",
          "Avoid dust exposure to prevent infections.",
          "Minimize your facial movements after the surgery.",
          "Minimize the intake of processed and sugar-based food to increase healing."
        ]
      },

      Faq: [
        {
          question: 'Is OMFS surgery painful?',
          answer: 'Generally the surgery is performed under anesthesia but little discomfort will be felt which is natural and can be managed with medications.'
        },
        {
          question: 'How long will it take to recover from the surgery?',
          answer: 'It depends on the type of surgery performed and based on the condition. Minor surgeries will take few days while major will take few weeks to months to fully recover.'
        },

      ],
      availableDoctors: {
        title: 'Meet our Professional and Skilled OMFS Surgeons at MagnAid Hospital',
        Doctors: [
          {
            photo: drsvg,
            doctorName: 'Dr. Ravishankar Nutalapati',
            profession: 'OMFS Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Subbiah Naidu',
            profession: 'OMFS Surgeon'
          },
          {
            photo: drsvg,
            doctorName: 'Dr. Shwetang G',
            profession: 'OMFS Surgeon'
          },
        ]
      }
    }
  ]
};

export default Departments;